{
  "de": {
    "account_deletion": "<p> Bitte klicken Sie auf den untenstehenden Link, um Ihr Benutzerkonto zu löschen. </p>\n<p> ACHTUNG: Diese Aktion kann nicht Rückgängig gemacht werden.</p>\n<p>%{link}</p>\n",
    "activerecord": {
      "attributes": {
        "addition": {
          "confirmation": "Legitimierung",
          "confirmation_checked": "Legitimierung prüfen",
          "confirmation_date": "Legitimierungsdatum",
          "form_checked": "Formular prüfen",
          "meta_data_checked": "Metadaten prüfen",
          "rejection": "Ablehnungsgrund",
          "status": "Status"
        },
        "additional_request": {
          "description": "Freitext",
          "file": "Angehängte Datei"
        },
        "annotation": {
          "confirmation": "Legitimierung",
          "confirmation_date": "Legitimierungsdatum",
          "rejection": "Ablehnungsgrund",
          "status": "Status"
        },
        "annotation_entry": {
          "value": "Ergänzung"
        },
        "attachment": {
          "abstract": "Abstract",
          "attached_file": "Angehängte Datei",
          "author": "Autor / Herausgeber des Dokuments",
          "checked": "Überprüft",
          "document_type": "Typ des Dokuments",
          "doi": "DOI",
          "link": "Link zur Publikation",
          "publication_organ": "Publikationsorgan",
          "published": "Anhang wird veröffentlicht",
          "pubmed": "PubMed-ID",
          "title": "Titel des Dokuments",
          "year": "Jahr der Erstellung / Veröffentlichung des Dokuments"
        },
        "confirmation": {
          "file": "Dokument"
        },
        "email": {
          "category": "Kategorie",
          "content": "Inhalt",
          "recipient": "Empfänger",
          "sender": "Sender",
          "sending_date": "Datum",
          "sending_time": "Uhrzeit",
          "subject": "Betreff"
        },
        "help_text": {
          "description": "Beschreibung",
          "name": "Name",
          "text": "Text",
          "title": "Titel"
        },
        "help_text_attachment": {
          "file": "Datei",
          "title": "Titel"
        },
        "help_text_link": {
          "description": "Beschreibung",
          "title": "Titel",
          "url": "URL"
        },
        "paragraph": {
          "description": "Beschreibung",
          "form": "Formular",
          "header": "Überschrift",
          "order": "Sortierung",
          "sequence": "Ordnungszahl"
        },
        "ris_attachment": {
          "attached_file": "Angehängte Datei"
        },
        "session": {
          "remember_me": "Angemeldet bleiben"
        },
        "upload": {
          "confirmation": "Legitimierung",
          "confirmation_checked": "Legitimierung prüfen",
          "confirmation_date": "Legitimierungsdatum",
          "form_checked": "Formular prüfen",
          "indication": "Indikation",
          "institution": "Institution",
          "intervention": "Intervention",
          "manufacturer": "Hersteller",
          "medical_device": "Produkt",
          "meta_data_checked": "Metadaten prüfen",
          "product_class": "Produktklasse",
          "publishing_comment": "Hinweis",
          "rejection": "Ablehnungsgrund",
          "status": "Status",
          "updated_at": "Aktualisiert am"
        },
        "user": {
          "admin?": "Ist Administrator",
          "city": "Ort",
          "confirmation_sent_at": "Bestätigung gesendet am",
          "confirmation_token": "Bestätigungs-Token",
          "confirmed_at": "Bestätigt am",
          "created_at": "Erstellt am",
          "current_password": "Bisheriges Passwort",
          "current_sign_in_at": "Aktuelle Anmeldung vom",
          "current_sign_in_ip": "IP aktueller Anmeldung",
          "email": "E-Mail",
          "encrypted_password": "Verschlüsseltes Passwort",
          "failed_attempts": "Fehlversuche",
          "first_name": "Vorname",
          "functional_role": "Fachliche Rolle",
          "institution": "Name der Institution",
          "last_name": "Nachname",
          "last_sign_in_at": "Letzte Anmeldung am",
          "last_sign_in_ip": "IP der letzten Anmeldung",
          "locked_at": "Gesperrt am",
          "login": "Benutzername",
          "name": "Vorname",
          "password": "Passwort",
          "password_confirm": "Passwortbestätigung",
          "password_confirmation": "Passwortbestätigung",
          "phone": "Telefon",
          "remember_created_at": "Angemeldet bleiben vom",
          "remember_me": "Angemeldet bleiben",
          "reset_password_sent_at": "Passwort-Zurücksetzen-E-Mail gesendet am",
          "reset_password_token": "Passwort-Zurücksetzen-Token",
          "salutation": "Anrede",
          "sector": "Nutzertyp / Branche",
          "sign_in_count": "Anzahl Anmeldungen",
          "street": "Straße / Hausnummer",
          "unconfirmed_email": "Unbestätigte E-Mail-Adresse",
          "unlock_token": "Entsperrungs-Token",
          "updated_at": "Aktualisiert am",
          "username": "Benutzernamen",
          "website": "Website",
          "zip": "PLZ"
        },
        "user_confirm_data": {
          "city": "Ort",
          "first_name": "Vorname",
          "last_name": "Nachname",
          "phone": "Telefon",
          "salutation": "Anrede",
          "sector": "Nutzertyp / Branche",
          "street": "Straße / Hausnummer",
          "zip": "PLZ"
        }
      },
      "default_user_password": "VuG6LZrcGo4C",
      "errors": {
        "messages": {
          "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Datensatz kann nicht gelöscht werden, da abhängige %{record} existieren.",
            "has_one": "Datensatz kann nicht gelöscht werden, da ein abhängiger %{record}-Datensatz existiert."
          }
        },
        "models": {
          "user": {
            "attributes": {
              "city": {
                "blank": "darf nicht leer sein"
              },
              "email": {
                "blank": "darf nicht leer sein",
                "taken": "ist im System bereits vorhanden",
                "wrong_format": "hat das falsche Format"
              },
              "first_name": {
                "blank": "darf nicht leer sein"
              },
              "last_name": {
                "blank": "darf nicht leer sein"
              },
              "password": {
                "blank": "darf nicht leer sein"
              },
              "phone": {
                "blank": "darf nicht leer sein"
              },
              "sector": {
                "blank": "darf nicht leer sein"
              },
              "street": {
                "blank": "darf nicht leer sein"
              },
              "zip": {
                "blank": "darf nicht leer sein"
              }
            }
          }
        }
      },
      "models": {
        "addition": {
          "one": "Informationsergänzung",
          "other": "Informationsergänzungen"
        },
        "additional_request": {
          "one": "Nachforderung",
          "other": "Nachforderungen"
        },
        "annotation": {
          "one": "Informationsergänzung",
          "other": "Informationsergänzungen"
        },
        "annotation_entry": {
          "one": "Ergänzungseintrag",
          "other": "Ergänzungseinträge"
        },
        "attachment": {
          "one": "Anhang",
          "other": "Anhänge"
        },
        "confirmation": {
          "one": "Legitimierungsdokument",
          "other": "Legitimierungsdokumente"
        },
        "email": "E-Mails",
        "email_singualar": "E-Mail",
        "help_text": "Hilfetext",
        "help_text_attachment": "Anhang",
        "help_text_link": "Link",
        "paragraph": "Abschnitt",
        "ris_attachment": {
          "one": "Gesamttreffer der Recherche",
          "other": "Gesamttreffer der Recherchen"
        },
        "upload": {
          "one": "Informationsübermittlung",
          "other": "Informationsübermittlungen"
        },
        "user": "Nutzer",
        "user_confirm_data": "Persönliche Daten"
      }
    },
    "acute_shortage": {
      "link_text": "Bearbeitung starten",
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab Unvollständigkeit der übermittelten Informationen",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang und Feststellung der formalen Vollständigkeit auf Vollständigkeit geprüft. Im Ergebnis der Prüfung auf Vollständigkeit bestehen erhebliche Unvollständigkeiten der übermittelten Informationen. Der G-BA fordert daher Informationen gemäß dem 2. Kapitel § 34 Absatz 3 Satz 3 und 4 VerfO nach. Diese können Sie dem beigefügten Schreiben entnehmen. Ihre Informationsübermittlung steht Ihnen im Portal 137h wieder zur Bearbeitung zur Verfügung:</p>\n<p>%{link}</p>\n%{free_text}\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "addition": {
      "create": {
        "success": "Erfolgreich legitimiert"
      },
      "delete": {
        "success": "Erfolgreich gelöscht"
      },
      "edit": {
        "headline": "Informationsergänzung bearbeiten"
      },
      "form_steps": {
        "step_one": {
          "paragraph1": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
          "paragraph2": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
          "paragraph3": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis porta urna.",
          "side_bar": {
            "file_size": "(PDF 51,7 kB)",
            "link": "Legitimierungsformular",
            "text": "Bevor Sie mit der Informationsergänzung starten können, müssen Sie sich legitimieren.",
            "title": "Hinweis"
          },
          "title": "Allgemeine Hinweise zur Informationsergänzung"
        },
        "step_two": {
          "side_bar": {
            "text": "Formular ausfüllen und unterschreiben lassen... Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis porta urna.",
            "title": "Hinweis"
          },
          "title": "Legitimierungsformular hochladen"
        },
        "submit": "Legitimierung abschließen"
      },
      "new": {
        "button": "Neue Informationsergänzung starten",
        "headline": "Neue Informationsergänzung starten"
      },
      "show": {
        "headline": "Verfahren nach § 137h SGB V"
      },
      "state_change": {
        "success": "Statuswechsel erfolgreich"
      },
      "upload-form": {
        "fallback": "Kein Formular vorhanden",
        "submit": "Speichern"
      }
    },
    "additional_request_final": {
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab formale Unvollständigkeit – Die Informationen gelten als nicht übermittelt.",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang zunächst auf formale Vollständigkeit geprüft. Im Ergebnis der Prüfung fehlt es an der formalen Vollständigkeit. Die Gründe können Sie dem beigefügten Schreiben entnehmen. Der Eingang der Informationen wird nicht auf der Internetseite des Gemeinsamen Bundesausschusses veröffentlicht und die Informationen gelten als nicht übermittelt.</p>\n%{free_text}\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "admin": {
      "users": {
        "active": {
          "deactivate": "Deaktiveren",
          "none": "keine aktiven Nutzer",
          "reactivate": "Aktivieren",
          "title": "Aktive Nutzer"
        },
        "confirmation_mail_send": "Die Bestätigungsmail wurde versandt.",
        "pending": {
          "deactivate": "Ablehnen",
          "none": "keine Nutzer freizuschalten",
          "title": "Nutzer freischalten"
        },
        "set_role": "Rolle zuweisen"
      }
    },
    "annotation_process_started_with_shortage": {
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung auf Vollständigkeit der übermittelten Informationen",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang und Feststellung der formalen Vollständigkeit auf Vollständigkeit geprüft. Die Durchführung des Informationsergänzungsverfahrens nach dem 2. Kapitel § 35 VerfO hat begonnen (siehe unter www.g-ba.de bei den Bewertungsverfahren).</p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "annotation_workflow_values": {
      "archived": {
        "back_transition_name": "Archiviert",
        "identifier_string": "annotation_archived",
        "status_name": "Archiviert",
        "transition_name": "Archiviert"
      },
      "confirmed": {
        "back_transition_name": "Bestätigt",
        "identifier_string": "annotation_confirmed",
        "status_name": "Bestätigt",
        "transition_name": "Bestätigt"
      },
      "draft": {
        "back_transition_name": "Entwurf",
        "identifier_string": "annotation_draft",
        "status_name": "Entwurf",
        "transition_name": "Entwurf"
      },
      "forward_to_review": {
        "back_transition_name": "Entwurf",
        "identifier_string": "annotation_forward_to_review",
        "status_name": "Bearbeitung abgeschlossen",
        "transition_name": "Ergänzende Informationen an den G-BA übermitteln"
      },
      "review": {
        "back_transition_name": "In Prüfung",
        "identifier_string": "annotation_review",
        "status_name": "Übermittelt",
        "transition_name": "In Prüfung"
      }
    },
    "annotations": {
      "add_entry": "Ergänzung hinzufügen",
      "box_header": "Eigene Ergänzung",
      "confirmation_success": "Legitimierung erfolgreich",
      "create_success": "Erfolgreich angelegt",
      "delete": {
        "confirm_delete": "Soll die Informationsergänzung wirklich gelöscht werden?",
        "success": "Erfolgreich gelöscht"
      },
      "dynamic_help_text": "Bitte begründen Sie Ihre Informationsergänzung möglichst durch Literatur (z.B. relevante Studien), indem Sie hier die Literatur auflisten und die zugehörigen Volltexte hochladen.",
      "edit": {
        "headline": "Informationsübermittlung ergänzen"
      },
      "edit_entry": "Ergänzung bearbeiten",
      "error": "Diese Aktion ist nicht zulässig.",
      "form_steps": {
        "step_one": {
          "paragraph1": "Mit der Bekanntmachung der von einem anfragenden Krankenhaus eingereichten Informationen eröffnet der Gemeinsame Bundesausschuss (G-BA) allen Krankenhäusern, die eine Erbringung der gegenständlichen Methode vorsehen, sowie den jeweils betroffenen Medizinprodukteherstellen die Möglichkeit zur Einreichung weiterer Informationen zur gegenständlichen Methode. Das Portal 137h ermöglicht es Ihnen, Ihre Informationsergänzung digital zu bearbeiten und an den G-BA zu übermitteln.",
          "paragraph2": "Bitte orientieren Sie sich bei Ihrer Informationsergänzung an der Struktur und den Angaben im vom anfragenden Krankenhaus eingereichten Formular. Das Formular finden Sie auf der Internetseite des G-BA und im Portal 137h nach Klicken des Buttons \"Neue Informationsergänzung starten\". Informationen, die bereits im eingereichten Formular angegeben sind, müssen Sie nicht wiederholen. Bitte begründen Sie Ihre Informationsergänzung möglichst durch Literatur (z. B. relevante Studien), listen Sie die Literatur im Portal 137h auf und übermitteln Sie die zugehörigen Volltexte.",
          "paragraph3": "Mit der Übermittlung ergänzender Informationen erklären Sie sich einverstanden, dass diese in den Beschlussdokumenten wiedergegeben und anschließend veröffentlich werden dürfen. Von Ihnen als hochvertraulich gekennzeichnete Informationen sind hiervon ausgenommen. Der G-BA wird unter Berücksichtigung der vom anfragenden Krankenhaus eingereichten sowie der ergänzten Informationen eine Entscheidung treffen, ob die Voraussetzungen einer Bewertung nach § 137h SGB V vorliegen. Falls die Voraussetzungen erfüllt sind, führt er auf Grundlage der Informationen die Bewertung nach § 137h SGB V durch.",
          "title": "Allgemeine Hinweise zur Informationsergänzung"
        },
        "step_two": {
          "side_bar": {
            "paragraph1": "Bitte geben Sie bei Institution den Namen des Krankenhauses oder des Herstellers an, in dessen Namen Sie die Informationsergänzung tätigen möchten, sowie den Namen Ihres Beratungsunternehmens.",
            "paragraph2": "Z.B. \"Krankenhaus X vertreten durch Beratungsunternehmen Y\" oder z.B. \"Hersteller X vertreten durch Beratungsunternehmen Y\".",
            "paragraph3": "Bitte laden Sie eine entsprechende Vollmacht als Anlage zur Informationsergänzung hoch.",
            "title": "Hinweis"
          },
          "title": "Name der Institution"
        },
        "submit": "Neue Informationsergänzung starten"
      },
      "index": {
        "headline": "Informationsergänzung"
      },
      "info_help_text": "Bitte tragen Sie hier nur allgemeine Anmerkungen ein, die nicht einem konkreten Abschnitt des Formulars zur Übermittlung von Informationen über den Stand der wissenschaftlichen Erkenntnisse zugeordnet werden können.",
      "link_add_entry": "neue Ergänzung",
      "link_delete_entry": "Löschen",
      "link_edit_entry": "Bearbeiten",
      "new": {
        "button": "Neue Informationsergänzung starten",
        "headline": "Neue Informationsergänzung starten"
      },
      "number": "Abschnitt, Nummer des Formulars",
      "required": "* Pflichtfeld",
      "show": {
        "annotation_header": "Informationsergänzung",
        "date": "Datum",
        "header": "Informationsergänzung zu einer neuen Untersuchungs- oder Behandlungsmethode mit einem Medizinprodukt hoher Risikoklasse gemäß § 137h SGB V",
        "info": "Orientieren Sie sich bei Ihrer Informationsergänzung an der Struktur und den Angaben im vom anfragenden Krankhaus eingereichten Formular. Das Formular hat der Gemeinsame Bundesausschuss auf seiner Internetseite eingestellt. Informationen, die bereits im eingereichten Formular angegeben sind, müssen Sie nicht wiederholen.",
        "info_header": "Informationsergänzung zum Formular",
        "item": "Nummer des Formulars",
        "method": "Methode",
        "name": "Krankenhaus/Medizinprodukthersteller",
        "no_entries": "Es wurden noch keine Ergänzungen hinzugefügt.",
        "paragraph": "Abschnitt",
        "site_name": "Ergänzung"
      },
      "status_error": "Diese Aktion ist nicht zulässig. Die Frist zur Informationsergänzung ist abgelaufen.",
      "update_success": "Aktualisierung erfolgreich",
      "value": "Informationsergänzung"
    },
    "approval": {
      "137h": {
        "IIIA_title": "Unterschrift zum Formularabschnitt III A (%{product}) erteilen",
        "IIIB_title": "Unterschrift zum Formularabschnitt III B und damit Einvernehmen mit der Informationsübermittlung erteilen",
        "hospital_title": "Unterschrift zum Formularabschnitt V und damit Genehmigung der Informationsübermittlung erteilen",
        "instructions": "<p>Bei Legitimierungsart digital: Bitte laden Sie den Formularabschnitt <br/> bzw. die Formularabschnitte nach getätigter digitaler Signatur im Portal 137h hoch.</p>\n<p>&nbsp;</p>\n<p>Bei Legitimierungsart Fax: Bitte drucken Sie den Formularabschnitt <br/> bzw. die Formularabschnitte aus, leisten Sie die Unterschrift und <br/> senden Sie das Dokument an folgende Fax-Nummer:</p>\n<p>&nbsp;</p>\n<p><b>%{fax_number}</b></p>\n",
        "left": "Datum, Ort",
        "right": "Unterschrift/Stempel",
        "title": "Unterschrift zum Formularabschnitt erteilen"
      }
    },
    "approval_confirmation": {
      "download_pdf": "Legitimierungsdokument als PDF-Datei",
      "download_zip": "Legitimierungsdokumente als ZIP-Datei",
      "headline_without_confirmations": "Keine Legitimierungsdokumente vorhanden"
    },
    "approval_documents": {
      "default": "upload",
      "editor": {
        "IIIA": "Abschnitt III A (%{product}) des Informationsübermittlungsformulars",
        "IIIB": "Abschnitt III B des Informationsübermittlungsformulars"
      },
      "owner": "Abschnitt I, II, IV und V des Informationsübermittlungsformulars"
    },
    "approval_process": {
      "confirmation": {
        "confirm_delete": "Dokument wirklich löschen?",
        "form": "Dokument",
        "header": "Dokument hochladen",
        "new": "Dokument hochladen",
        "no_forms": "Hier können Sie Ihre signierten Formularabschnitte, falls Sie sich für die digitale Signatur entschieden haben, und ggf. Vollmachten für bevollmächtigte Personen oder Unternehmen hochladen.",
        "submit": "Hochladen"
      },
      "header": "Legitimierung"
    },
    "attachments": {
      "add_attachemnts": "Anlagen pflegen",
      "add_literature": "Literatur pflegen",
      "annotation_attachment": "Anhang zu einer Informationsergänzung von ",
      "annotation_attachments": {
        "headline": "Anhänge zur Informationsergänzung"
      },
      "attachments_as_pdf": "Vollständige Liste der Anlagen als PDF-Datei",
      "attachments_as_pdf_short": "Anlagenliste als PDF-Datei",
      "attachments_as_ris": "Vollständige Liste der Anlagen als RIS-Datei",
      "attachments_as_ris_short": "Anlagenliste als RIS-Datei",
      "attachments_as_zip_short": "Anlagen als ZIP-Datei",
      "confirm_delete": "Eintrag wirklich löschen?",
      "delete": {
        "success": "Erfolgreich gelöscht"
      },
      "edit": {
        "attachment_headline": "Anlage bearbeiten",
        "checked": "Anhang überprüft",
        "literature_headline": "Literatur bearbeiten",
        "publishing": "Anhang veröffentlichen",
        "review_headline": "Anhang prüfen",
        "success": "Erfolgreich gespeichert"
      },
      "in_review": " (In Prüfung)",
      "link_edit": "Anhänge bearbeiten",
      "link_new": "Anhang hinzufügen",
      "literature_as_pdf": "Vollständige Liste der Literatur als PDF-Datei",
      "literature_as_pdf_short": "Literaturliste als PDF-Datei",
      "literature_as_ris": "Vollständige Liste der Literatur als RIS-Datei",
      "literature_as_ris_short": "Literaturliste als RIS-Datei",
      "literature_as_zip_short": "Literatur als ZIP-Datei",
      "new": {
        "attachment_headline": "Neue Anlage",
        "link": "Anhang hinzufügen",
        "literature_headline": "Neue Literatur",
        "success": "Erfolgreich gespeichert",
        "title": "Bitte füllen Sie die Felder aus und wählen Sie eine Datei:"
      },
      "no_attachments": " (Keine Anlagen vorhanden)",
      "no_literature": " (Keine Literatur vorhanden)",
      "no_literature_entries": "Keine Literatureinträge vorhanden",
      "non_public": " (nicht öffentlich)",
      "overview": {
        "attachment_headline": "Anlagen",
        "literature_headline": "Literaturliste",
        "new_attachment": "Neue Anlage",
        "new_literature": "Neue Literatur",
        "no_attachments": "Noch keine Anlagen hinzugefügt",
        "no_literature": "Noch keine Literatur hinzugefügt"
      },
      "own_attachment": "Eigener Anhang",
      "required": "* Pflichtfeld",
      "show": {
        "delete": "Löschen",
        "document": "Dokument ansehen",
        "edit": "Bearbeiten",
        "review": "Prüfen",
        "show": "Anzeigen"
      },
      "submit": "Speichern",
      "table": {
        "checked": "Überprüft",
        "no_entries": "Keine Anhänge vorhanden",
        "published": "Veröffentlicht"
      },
      "upload_attachment": "Anhang zur Informationsübermittlung",
      "upload_attachments": {
        "headline": "Anhänge zur Informationsübermittlung"
      }
    },
    "authorization": {
      "no_access": "Sie sind nicht berechtigt auf die Seite zuzugreifen.",
      "no_permission_edit": "Sie sind nicht berechtigt die Seite zu bearbeiten."
    },
    "check_point_values": {
      "review_completeness_cp_1": {
        "description": "Bestätigung in Abschnitt I Nummer 4.1, dass eine entsprechende NUB-Anfrage gestellt wurde",
        "display_name": "Abschnitt I Nummer 4.1 - NUB-Anfrage",
        "identifier_string": "review_completeness_cp_1"
      },
      "review_completeness_cp_2": {
        "description": "Angaben zu der Methode in Abschnitt I Nummer 4.2a und Abschnitt II Nummer 2.3",
        "display_name": "Abschnitt I Nummer 4.2a und Abschnitt II Nummer 2.3 - Methoden Angaben",
        "identifier_string": "review_completeness_cp_2"
      },
      "review_completeness_cp_3": {
        "description": "Angaben zum Medizinprodukt und über den Stand der wissenschaftlichen Erkenntnisse in Abschnitt III A nebst zugehöriger Anlagen",
        "display_name": "Abschnitt III A - Angaben zum Medizinprodukt",
        "identifier_string": "review_completeness_cp_3"
      },
      "review_completeness_cp_4": {
        "description": "Erklärung des Einvernehmens des Medizinprodukteherstellers in Abschnitt III B",
        "display_name": "Abschnitt III B - Einvernehmen",
        "identifier_string": "review_completeness_cp_4_producer_signature"
      },
      "review_completeness_cp_5": {
        "description": "Unterschrift einer für das Krankenhaus vertretungsberechtigten Person oder einer von ihr bevollmächtigten Person in Abschnitt V. Fehlt es an einer dieser Voraussetzungen, gelten die übermittelten Informationen als nicht eingegangen und das KH wird hierüber informiert",
        "display_name": "Abschnitt V - Unterschrift Krankenhaus",
        "identifier_string": "review_completeness_cp_5_hospital_signature"
      },
      "review_completeness_cp_6": {
        "description": "Es muss geprüft werden, ob zu dieser Methode bereits eine Informationsübermittlung vorliegt.",
        "display_name": "Informationsübermittlung zur Methode bereits vorliegend",
        "identifier_string": "review_completeness_cp_6_method_already_exist"
      },
      "review_plausibility_cp_1": {
        "description": "Bitte die eingereichten Unterlagen auf inhaltliche Vollständigkeit (inklusive Angaben zum PICO) prüfen, ggf. ein Nachforderungsschreiben entwerfen und anschließend nach Klicken des Buttons \"Nächster Schritt\" das Ergebnis der Prüfung auf inhaltliche Vollständigkeit auswählen.",
        "display_name": "Inhaltliche Vollständigkeitsprüfung",
        "identifier_string": "review_plausibility_cp_1"
      },
      "review_plausibility_cp_2": {
        "description": "Nachdem Sie den Button \"Nächster Schritt\" geklickt haben, bitte zunächst die Metadaten prüfen, bevor Sie das Ergebnis der Prüfung auf inhaltliche Vollständigkeit wählen. Bei den Metadaten können Sie die vom G-BA gewählte Methodenbezeichnung, die Vorgangsnummer, den Link zum Bewertungsverfahren auf der G-BA Website, das Startdatum des Bewertungsverfahrens sowie das Start- und Enddatum des Informationsergänzungsverfahrens angeben bzw. anpassen.",
        "display_name": "Metadaten prüfen",
        "identifier_string": "review_plausibility_cp_2_metadata"
      }
    },
    "claim": {
      "first_hint": "Ihr Benutzerkonto wurde einer durch ein Krankenhaus gestarteten Informationsübermittlung gemäß § 137h SGB V zugeordnet!",
      "header": "Hersteller zugeordnet",
      "second_hint": "Ein Krankenhaus hat eine Informationsübermittlung über das Portal 137h des Gemeinsamen Bundesausschusses gestartet und Sie als betroffenen Medizinproduktehersteller des bei der gegenständlichen Methode zum Einsatz kommenden Medizinprodukts hoher Risikoklasse zur gemeinsamen Bearbeitung der Informationsübermittlung gemäß § 137h SGB V eingeladen. Um als betroffener Medizinproduktehersteller die Abschnitte III A und III B des Informationsübermittlungsformulars auszufüllen, klicken Sie bitte auf \"Meine Verfahren\" und folgen den dort angezeigten Schritten."
    },
    "confirm_message": "Sind Sie sich sicher, dass sie den Nutzer löschen wollen?",
    "confirmation_instructions": {
      "message": "<p> Sehr geehrte Damen und Herren,</p>\n<p> im Portal 137h zur digitalen Informationsübermittlung an den Gemeinsamen Bundesausschuss im Rahmen von Bewertungsverfahren nach § 137h SGB V\n    wurde eine Registrierung für ein Benutzerkonto unter Verwendung Ihrer E-Mail-Adresse angelegt. Bitte klicken Sie auf den nachfolgenden Link \"Bestätigen\"\n    um die Registrierung abzuschließen (der Link ist 48 Stunden gültig). Vielen Dank. </p>\n<p> %{link} </p>\n<p> Bitte beachten Sie, dass nach Abschluss der Registrierung noch eine Prüfung und Freigabe der Registrierung durch die Geschäftsstelle des\n    Gemeinsamen Bundesausschuss erforderlich ist, um Ihr Benutzerkonto endgültig freizuschalten. Sie werden über die Freigabe in der Regel innerhalb\n    von einem Werktag gesondert informiert. Sie können Ihr Benutzerkonto nach Freigabe unmittelbar nutzen. </p>\n<p> Sollten Sie die Registrierung nicht selber vorgenommen und auch nicht autorisiert haben, klicken Sie nicht auf den Link \"Bestätigen\". Der Link verfällt automatisch nach Ablauf der 48 Stunden. </p>\n<p> Diese Nachricht wurde automatisch generiert. </p>\n<p> Mit freundlichen Grüßen </p>\n"
    },
    "confirmations": {
      "account_deletion": {
        "headline": "Account-Löschung erfolgreich abgeschlossen."
      },
      "resend_confirmation": {
        "headline": "Es wurde ein neuer Bestätigungslink versendet!"
      },
      "show": {
        "confirmed": {
          "headline": "Registrierung erfolgreich!",
          "paragraph1": "Ihr Nutzerkonto ist noch nicht aktiviert.",
          "paragraph2": "Die Angaben zur Registrierung Ihres Nutzerkontos liegen uns vollständig vor und werden durch die Geschäftsstelle des G-BA geprüft. Bis zur Freigabe kann das Nutzerkonto nicht verwendet werden.",
          "paragraph3": "Über die Freigabe erhalten Sie in der Regel 24 Stunden nach abgeschlossener Registrierung (bezogen auf Werktage) eine gesonderte Information."
        },
        "expired": {
          "headline": "Der Link ist abgelaufen!",
          "new_confirmation_link": "Neuen Bestätigungslink anfordern"
        }
      },
      "upload": {
        "back": "Zurück",
        "description": "Bitte geben Sie einen Hinweistext für die Bestätigung ein:",
        "required": "* Pflichtfeld",
        "sitename": "Bestätigung"
      }
    },
    "confirmed_annotation_notification": {
      "subject": "Portal 137h | Informationsergänzung wurde übermittelt",
      "text": "Ihre Informationsergänzung gemäß dem 2. Kapitel § 35 der Verfahrensordnung des Gemeinsamen Bundesausschusses im Rahmen des Verfahrens nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" wurde an den Gemeinsamen Bundesausschuss gesendet."
    },
    "confirmed_upload_notification": {
      "subject": "Bestätigung Ihrer Informationsübermittlung im Bewertungsverfahren gemäß § 137h SGB V",
      "text": "<p> Sehr geehrte Damen und Herren,</p>\n<p> im Portal 137h zur digitalen Informationsübermittlung an den Gemeinsamen Bundesausschuss im Rahmen von Bewertungsverfahren nach § 137h SGB V haben Sie über Ihr Benutzerkonto Informationen gemäß § 137h Absatz 1 SGB V an den Gemeinsamen Bundesausschuss übermittelt. Die Geschäftsstelle des Gemeinsamen Bundesausschusses hat die eingegangenen Informationen auf formale Vollständigkeit geprüft und die formale Vollständigkeit festgestellt. Der Eingang der Informationen wird öffentlich auf den Internetseiten des Gemeinsamen Bundesausschusses und des Portal 137h bestätigt und damit das Bewertungsverfahren nach § 137h SGB V eingeleitet. </p>\n<p> Mit freundlichen Grüßen </p>\n"
    },
    "contact": {
      "address": {
        "city": "10587 Berlin",
        "headline": "Adresse",
        "name": "Gemeinsamer Bundesausschuss",
        "street": "Gutenbergstraße 13"
      },
      "contact_form": {
        "breadcrumb": "Anfrage",
        "city": "PLZ / Ort",
        "email": "Ihre E-Mail-Adresse",
        "first_name": "Vorname",
        "headline": "Kontaktformular",
        "last_name": "Nachname",
        "organization": "Organisation",
        "request": "Ihre Anfrage / Ihr Anliegen",
        "required": "* Pflichtfelder",
        "street": "Straße / Hausnummer",
        "subject": "Betreff",
        "submit": "Senden",
        "success": "Ihre Anfrage wird in Kürze bearbeitet.",
        "telephone": "Telefon"
      },
      "contact_form_email": {
        "email": "E-Mail-Adresse",
        "request": "Anfrage/Anliegen"
      },
      "email": {
        "description": "Um Ihre Anfrage zu den Richtlinien und Beschlüssen des G-BA schnellstmöglich beantworten zu können, nutzen Sie bitte das Kontaktformular",
        "headline": "E-Mail"
      },
      "headline": "Kontakt",
      "mailing_address": {
        "box": "Postfach 120606",
        "headline": "Postanschrift",
        "name": "Gemeinsamer Bundesausschuss",
        "postal_code": "10596 Berlin"
      }
    },
    "contact_request": {
      "city": "<p><b>PLZ/Ort:</b> %{city}</p>\n",
      "street": "<p><b>Straße/Hausnummer:</b> %{street}</p>\n",
      "subject": "Kontaktanfrage auf dem Portal137h",
      "telephone": "<p><b>Telefon:</b> %{telephone}</p>\n",
      "text1": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> über das Portal 137h ist folgende Anfrage an die Geschäftsstelle des G-BA eingegangen:</p>\n<br>\n<p><b>Nachname:</b> %{last_name}</p>\n<p><b>Vorname:</b> %{first_name}</p>\n",
      "text2": "<p><b>E-Mail-Adresse:</b> %{email}</p>\n<p><b>Organisation:</b> %{organization}</p>\n<br>\n<p><b>Betreff:</b> %{subject}</p>\n<br>\n<p><b>Anfrage/Anliegen:</b> %{request}</p>\n"
    },
    "cover": {
      "137h": {
        "addition": {
          "description": "(Weitere medizinproduktbezogene Angaben des Herstellers)",
          "headline": "Formular zur Übermittlung von Informationen über den Stand der wissenschaftlichen Erkenntnisse für die Bewertung einer neuen Untersuchungs- oder Behandlungsmethode mit Medizinprodukten hoher Risikoklasse gemäß § 137h SGB V",
          "part": "- Abschnitt III B - "
        },
        "upload": {
          "description": "für die Bewertung einer<br> neuen Untersuchungs- oder Behandlungsmethode<br> mit Medizinprodukten hoher Risikoklasse<br> nach <span style='white-space: nowrap'>§ 137h</span> SGB V",
          "head": "Anlage V zum 2. Kapitel VerfO",
          "headline": "Übermittlung von Informationen über den<br> Stand der wissenschaftlichen Erkenntnisse",
          "hospital": "%{hospital}",
          "method_description": {
            "date": "Stand: %{date}",
            "description": "Bezeichnung der Methode:",
            "method": "%{intervention} bei %{indication}"
          }
        }
      }
    },
    "dashboard": {
      "admin": {
        "all_users": "Alle Nutzer anzeigen",
        "email": "Liste der versendeten E-Mails",
        "header": "Administrative Funktionen",
        "help_text": "Hilfetexte",
        "new_user": "Neuen internen Mitarbeiter anlegen",
        "version": "Version"
      },
      "annotations": {
        "all_annotations": "Alle Informationsergänzungen",
        "confirmation_already_checked": "Hinweis: Die Legitimierung wurde bereits durch einen Mitarbeiter geprüft und bestätigt und kann daher nicht mehr geändert werden",
        "confirmation_checked": "Legitimierung überprüft",
        "entries_exists": "Ergänzungen hinzugefügt",
        "form_checked": "Formular überprüft",
        "meta_data_checked": "Metadaten überprüft",
        "new_confirmation": "Neue Legitimierung",
        "none": "Keine Informationsergänzungen vorhanden",
        "own_annotations": "Eigene Informationsergänzungen",
        "own_confirmation": "Legitimierung",
        "own_draft": "Zu bearbeitende Informationsergänzungen (Status: Entwurf)",
        "required_fields": "Alle Pflichtfelder ausgefüllt",
        "review": "Zu überprüfende Informationsergänzungen (Status: In Prüfung)",
        "review_annotation": "Formular prüfen",
        "show_all": "Alle Informationsergänzungen anzeigen",
        "show_all_own": "Alle eigenen Informationsergänzungen anzeigen",
        "show_annotatable_uploads": "Ergänzbare Übermittlungen anzeigen",
        "update_confirmation": "Legitimierung aktualisieren",
        "view_confirmation": "Legitimierung prüfen"
      },
      "attachment_steps": "Anlagen",
      "back": "Zurück",
      "back_step": "Zurück zu",
      "confirmations": "Legitimierungsdokumente",
      "consultant": {
        "text": "Hier kann man demnächst aktuelle Vorgänge einsehen",
        "title": "Dashboard Berater für Krankenhaus"
      },
      "declined": {
        "text": "Leider konnten wir Ihre Anmeldung nicht berücksichtigen.",
        "title": "Anmeldung abgelehnt"
      },
      "done": "Erledigt",
      "downloads": "Downloads",
      "edit_attachments": "Anhänge bearbeiten",
      "edit_comment": "Hinweis bearbeiten",
      "edit_upload": "Formular bearbeiten",
      "external_tab_menu_labels": {
        "abo": "Aboverwaltung",
        "annotation": "Eigene Informationsergänzungen",
        "upload": "Eigene Informationsübermittlungen"
      },
      "fax_pdf": "Dokumente für die Legitimierung per Fax herunterladen",
      "form_steps": "Formular",
      "hospital_user": {
        "text": "Hier kann man demnächst aktuelle Vorgänge einsehen",
        "title": "Dashboard Krankenhausmitarbeiter"
      },
      "internal_tab_menu_labels": {
        "additional_request": "Offene Nachforderungen",
        "admin": "Adminbereich",
        "annotation": "Informationserganzungen",
        "upload": "Informationsübermittlungen",
        "user": "Nutzerverwaltung"
      },
      "next_step": "Weiter zu",
      "pending": {
        "text": "Ihre Anmeldung wird nun überprüft und Sie erhalten eine Bestätigung, wenn Sie freigeschalten worden sind.",
        "title": "Willkommen"
      },
      "producer": {
        "text": "Hier kann man demnächst aktuelle Vorgänge einsehen",
        "title": "Dashboard Medizinproduktehersteller"
      },
      "publishing_steps": "Freigabeprozess",
      "review_attachments": "Anhänge prüfen",
      "review_html": "Formular prüfen (Html)",
      "review_pdf": "Formular prüfen",
      "ris_attachment": "Gesamttreffer der Recherchen",
      "show_attachments": "Anhänge anzeigen",
      "show_html": "Formular anzeigen (Html)",
      "show_pdf": "Formular anzeigen (PDF)",
      "specialist": {
        "text": "Hier erscheinen demnächst die neuen Vorgänge",
        "title": "Dashboard G-BA Fachanwender"
      },
      "submit": "Speichern",
      "subscriptions": {
        "confirm_delete": "Abo wirklich beenden?",
        "none": "Keine Abos vorhanden",
        "title": "Abos verwalten (Bei Änderungen werden Sie informiert)"
      },
      "tab_menu": {
        "additional_request": "OffeneNachforderungen",
        "admin": "Adminbereich",
        "annotation": "Informationsergaenzungen",
        "upload": "Informationsuebermittlungen",
        "user": "Nutzerverwaltung"
      },
      "todo": "Noch nicht erledigt",
      "uploads": {
        "approval": "Zu legitimierende Informationsübermittlungen (Status: Legitimierung)",
        "approval_process_link": "Legitimierung",
        "change_own_upload_meta_data": "Metadaten ändern",
        "check_point_processing": "Hinweise zur Prüfung",
        "confirmation_checked": "Legitimierung überprüft",
        "confirmed": "Bestätigte Informationsübermittlungen (Status: Bestätigt)",
        "form_checked": "Formular überprüft",
        "hospital_draft_finished_hint": "Sie können die Bearbeitung abschließen, sobald alle Pflichtfelder ausgefüllt sind, Hersteller zugeordnet wurde(n) und der / die zugeordnete(n) Hersteller oder vom Hersteller bevollmächtigten Personen oder Unternehmen die Bearbeitung abgeschlossen haben.",
        "manufacturer_overview": "Hersteller und Produkte verwalten",
        "mark_as_approval_finished_hint": "Ihre Legitimierung ist abgeschlossen. Das Krankenhaus kann die Informationen an den G-BA übermitteln, sobald es seine Bearbeitung und Legitimierung abgeschlossen hat.",
        "meta_data_checked": "Metadaten überprüft",
        "new_annotation": "Ergänzung hinzufügen",
        "new_confirmation": "Neue Legitimierung",
        "none": "Keine Informationsübermittlungen vorhanden",
        "own_confirmation": "Legitimierung",
        "own_draft": "Zu bearbeitende Informationsübermittlungen (Status: Entwurf)",
        "own_with_annotation": "Zu ergänzende Informationsübermittlungen (Status: Bekanntgemacht mit Ergänzung)",
        "procedure_finished": "Nicht übermittelte Informationsübermittlungen (Status: Verfahren beendet)",
        "required_fields": "Alle Pflichtfelder ausgefüllt",
        "review": "Zu überprüfende Informationsübermittlungen (Status: In Prüfung)",
        "review_annotation": "Informationsübermittlungen mit laufenden IEV (Status: Bekanntmachung erfolgt)",
        "review_completeness": "Zu überprüfende Informationsübermittlungen (Status: Prüfung auf formale Vollständigkeit)",
        "review_finished": "Zu archivierende Informationsübermittlungen (Status: Informationsergänzungsverfahren abgeschlossen)",
        "review_plausibility": "Zu überprüfende Informationsübermittlungen (Status: Prüfung auf inhaltliche Vollständigkeit)",
        "review_upload": "Formular prüfen",
        "show_all": "Archivierte Informationsübermittlungen anzeigen",
        "show_all_own": "Alle eigenen Informationsübermittlungen anzeigen",
        "start_new_annotations": "Ergänzungen hinzufügen",
        "update_confirmation": "Legitimierung aktualisieren",
        "upload_metadata": "Metadaten prüfen",
        "user_finished": "Bearbeitung abschließen",
        "user_selected": "Hersteller oder Produkt zugeordnet",
        "view_confirmation": "Legitimierung prüfen"
      },
      "user": {
        "details": "Bearbeiten",
        "none": "Keine Nutzer zum Freischalten vorhanden",
        "waiting_for_update_confirmation": "Wartet auf Freischaltung geänderter Nutzerdaten"
      }
    },
    "dashboard_name_external": "Meine Verfahren",
    "dashboard_name_internal": "Dashboard",
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "long": "%e. %B %Y",
        "short": "%e. %b"
      },
      "month_names": [
        null,
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "etwa eine Stunde",
          "other": "etwa %{count} Stunden"
        },
        "about_x_months": {
          "one": "etwa ein Monat",
          "other": "etwa %{count} Monate"
        },
        "about_x_years": {
          "one": "etwa ein Jahr",
          "other": "etwa %{count} Jahre"
        },
        "almost_x_years": {
          "one": "fast ein Jahr",
          "other": "fast %{count} Jahre"
        },
        "half_a_minute": "eine halbe Minute",
        "less_than_x_minutes": {
          "one": "weniger als eine Minute",
          "other": "weniger als %{count} Minuten"
        },
        "less_than_x_seconds": {
          "one": "weniger als eine Sekunde",
          "other": "weniger als %{count} Sekunden"
        },
        "over_x_years": {
          "one": "mehr als ein Jahr",
          "other": "mehr als %{count} Jahre"
        },
        "x_days": {
          "one": "ein Tag",
          "other": "%{count} Tage"
        },
        "x_minutes": {
          "one": "eine Minute",
          "other": "%{count} Minuten"
        },
        "x_months": {
          "one": "ein Monat",
          "other": "%{count} Monate"
        },
        "x_seconds": {
          "one": "eine Sekunde",
          "other": "%{count} Sekunden"
        },
        "x_years": {
          "one": "ein Jahr",
          "other": "%{count} Jahr"
        }
      },
      "prompts": {
        "day": "Tag",
        "hour": "Stunden",
        "minute": "Minute",
        "month": "Monat",
        "second": "Sekunde",
        "year": "Jahr"
      }
    },
    "deadline": {
      "begin_annotation": "Beginn Informationsergänzung:",
      "begin_assessment": "Beginn des Bewertungsverfahrens:",
      "end_annotation": "Ende Informationsergänzung:",
      "end_assessment": "Ende des Bewertungsverfahrens:"
    },
    "default": {
      "form": {
        "confirm": "Bestätigen",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "error": "Ein Fehler ist aufgetreten",
        "new": "Neu",
        "not_allowed": "Nicht erlaubt",
        "reject": "Ablehnen",
        "save": "Speichern",
        "success": "Erfolgreich",
        "update": "Aktualisieren"
      }
    },
    "deleted_user": "gelöschter Nutzer",
    "delted_user_email": "geloeschterNutzer%{number}@geloeschterNutzer.nix",
    "devise": {
      "confirmations": {
        "account_deleted": "Ihr Konto wurde gelöscht",
        "confirmed": "Ihre E-Mail-Adresse wurde erfolgreich bestätigt.",
        "deletion_mail_sent": "Sie erhalten in Kürze per E-Mail einen Link zum Löschen Ihres Kontos.",
        "email_change_notification": "Ihnen wurde eine Email gesendet zum Bestätigen der neuen Emailadresse zugeschickt. Erst nach der Bestätigung ist die neue Emailadresse aktiv.",
        "email_reset_instruction": "Sie erhalten eine E-Mail, um Ihre neue E-Mail zu bestätigen.",
        "email_updated": "Ihre E-Mail-Adresse wurde geändert.",
        "new": {
          "resend_confirmation_instructions": "Anleitung zur Bestätigung erneut senden"
        },
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können."
      },
      "failure": {
        "already_authenticated": "Sie sind bereits angemeldet.",
        "deletion_link_expired": "Der Link zum Löschen ihres Accounts ist abgelaufen. Er hat eine Gültigkeit von 24 Stunden. Bitte führen Sie das Löschen Ihres Accounts erneut aus. Sie erhalten dann per Mail einen neuen gültigen Link",
        "email_update_faild": "E-Mail-Änderung fehlgeschlagen.",
        "inactive": "Ihr Account ist nicht aktiv.",
        "invalid": "%{authentication_keys} oder Passwort ungültig.",
        "invalid_deletion_url": "Der Link zum Löschen des Kontos ist ungültig",
        "last_attempt": "Sie haben noch einen Versuch, bis Ihr Account gesperrt wird.",
        "locked": "Ihr Account ist gesperrt. Nach einer Stunde können Sie den Login erneut versuchen.",
        "not_available": "Ihr Account wurde noch nicht in der Applikation freigeschaltet.",
        "not_found_in_database": "%{authentication_keys} oder Passwort ungültig.",
        "not_in_group": "Ihr Account besitzt nicht die notwendigen Berechtigungen im ActiveDirectory.",
        "timeout": "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.",
        "unauthenticated": "Sie müssen sich anmelden oder registrieren, bevor Sie fortfahren können.",
        "unconfirmed": "Sie müssen Ihren Account bestätigen, bevor Sie fortfahren können."
      },
      "mailer": {
        "account_deletion": {
          "greeting": "Hallo %{recipient}!",
          "subject": "Anleitung zum Löschen Ihres Kontos"
        },
        "confirmation_instructions": {
          "action": "Mein Konto bestätigen",
          "greeting": "Willkommen %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu bestätigen:",
          "subject": "Anleitung zur Bestätigung Ihres Accounts"
        },
        "email_changed": {
          "greeting": null,
          "message": null,
          "subject": null
        },
        "password_change": {
          "greeting": "Hallo %{recipient}!",
          "message": "Wir kontaktieren Sie, um Ihnen mitzuteilen, dass Ihr Passwort geändert wurde.",
          "subject": "Passwort geändert"
        },
        "reset_password_instructions": {
          "action": "Passwort ändern",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern. Klicken Sie auf den unten aufgeführten Link um das Passwort zu ändern.",
          "instruction_2": "Bitte ignorieren Sie diese E-Mail, wenn Sie kein neues Passwort angefordert haben.",
          "instruction_3": "Das Passwort wird nicht geändert bis Sie den obenstehenden Link abrufen und ein neues Passwort bestimmen.",
          "subject": "Anleitung für das Zurücksetzen Ihres Passworts"
        },
        "unlock_instructions": {
          "action": "Mein Konto entsperren",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu entsperren:",
          "message": "Ihr Konto wurde aufgrund einer großen Anzahl von fehlgeschlagenen Anmeldeversuchen gesperrt.",
          "subject": "Anleitung für die Account-Freischaltung"
        }
      },
      "omniauth_callbacks": {
        "failure": "Sie konnten nicht mit Ihrem %{kind}-Account angemeldet werden, weil \"%{reason}\".",
        "success": "Sie haben sich erfolgreich mit Ihrem %{kind}-Account angemeldet."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ändere mein Passwort",
          "change_your_password": "Passwort ändern",
          "confirm_new_password": "Neues Passwort bestätigen",
          "new_password": "Neues Passwort",
          "resend_link": "Link zum Zurücksetzen des Passworts erneut senden"
        },
        "new": {
          "forgot_your_password": "Haben Sie Ihr Passwort vergessen?",
          "password_reset": "Passwort zurücksetzen",
          "send_me_reset_password_instructions": "Schicken Sie mir die Anleitung, mein Passwort zurückzusetzen"
        },
        "no_token": "Sie können sich nicht auf dieser Seite anmelden, wenn Sie nicht von einer Passwort-Zurücksetzen-E-Mail kommen. Wenn Sie von solch einer E-Mail kommen, überprüfen Sie bitte, ob Sie die gesamte URL verwendet haben.",
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können.",
        "updated": "Ihr Passwort wurde geändert. Sie sind jetzt angemeldet.",
        "updated_not_active": "Ihr Passwort wurde geändert."
      },
      "registrations": {
        "destroyed": "Ihr Account wurde gelöscht.",
        "edit": {
          "are_you_sure": "Sind Sie sicher?",
          "cancel_my_account": "Konto löschen",
          "change_data": "Daten ändern",
          "change_personal_data": "Persönliche Daten ändern",
          "currently_waiting_confirmation_for_email": "Warte auf Bestätigung von %{email}.",
          "email_change": "E-Mail-Adresse ändern",
          "leave_blank_if_you_don_t_want_to_change_it": "(freilassen, wenn Sie das nicht ändern wollen)",
          "settings": "Account",
          "title": "%{resource} bearbeiten",
          "unhappy": "Unglücklich?",
          "update": "Aktualisieren",
          "update_institution_website": "Institution und Webseite ändern",
          "we_need_your_current_password_to_confirm_your_changes": "(Wir benötigen Ihr aktuelles Passwort, um die Änderung zu bestätigen)"
        },
        "new": {
          "sign_up": "Registrieren"
        },
        "signed_up": "Sie haben sich erfolgreich registriert.",
        "signed_up_but_inactive": "Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account noch nicht aktiviert ist.",
        "signed_up_but_locked": "Sie haben sich erfolgreich registriert. Wir konnten Sie jedoch nicht anmelden, weil Ihr Account gesperrt ist.",
        "signed_up_but_unconfirmed": "Sie erhalten in wenigen Minuten eine E-Mail mit einem Link für die Bestätigung der Registrierung. Klicken Sie auf den Link um Ihren Account zu aktivieren.",
        "update_needs_confirmation": "Ihre Daten wurden aktualisiert, aber Sie müssen Ihre neue E-Mail-Adresse bestätigen. Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie die Änderung Ihrer E-Mail-Adresse abschließen können.",
        "updated": "Ihre Daten wurden aktualisiert."
      },
      "sessions": {
        "already_signed_out": "Erfolgreich abgemeldet.",
        "new": {
          "header": "Portal 137h",
          "sign_in": "Anmelden"
        },
        "required": "* Pflichtfelder",
        "sign_out": "Abmelden",
        "signed_in": "",
        "signed_out": "Erfolgreich abgemeldet."
      },
      "shared": {
        "links": {
          "back": "Zurück",
          "didn_t_receive_confirmation_instructions": "Keine Anleitung zur Bestätigung erhalten?",
          "didn_t_receive_unlock_instructions": "Keine Anleitung zum Entsperren erhalten?",
          "forgot_your_password": "Passwort vergessen?",
          "sign_in": "Anmelden",
          "sign_in_with_provider": "Mit %{provider} anmelden",
          "sign_up": "Registrieren"
        },
        "minimum_password_length": null
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Anleitung zum Entsperren noch mal schicken"
        },
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihren Account entsperren können.",
        "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail, mit der Anleitung, wie Sie Ihren Account entsperren können.",
        "unlocked": "Ihr Account wurde entsperrt. Bitte melden Sie sich an, um fortzufahren."
      }
    },
    "document_types": {
      "other": "Sonstiges",
      "paper": "Wissenschaftliche Publikation",
      "technical_info": "Technische Informationen"
    },
    "email_category": {
      "acute_shortage": "Unvollständig grobe Mängel",
      "additional_request_final": "Finales Schreiben",
      "annotation_process_started_with_shortage": "Informationsergänzungsverfahren gestartet trotz Nachforderungen",
      "confirmation_instructions": "Registrierungsbestätigung",
      "confirmed_annotation_notification": "Bestätigungsbenachrichtigung (Ergänzung)",
      "confirmed_upload_notification": "Bestätigungsbenachrichtigung (Übermittlung)",
      "contact_request": "Kontaktanfrage",
      "delete_account_notification": "Account löschen",
      "email_reset_notification": "E-Mail ändern",
      "incomplete": "Formal unvollständig",
      "information": "Information",
      "internal_user_password_instruction": "Passworterstellung (interner Nutzer)",
      "manufacturer_invite": "Hersteller Einladung",
      "method_already_existing": "Methode bereits vorhanden",
      "new_annotation_notification": "Neue Informationsübermittlung",
      "new_upload_notification": "Neue Informationsübermittlung",
      "password_change": "Passwort geändert",
      "registration_notification": "Registrierungshinweis",
      "reset_password_instructions": "Passwort ändern",
      "small_shortage": "Unvollständig kleine Mängel",
      "subscription_annotation": "Abonnement: Ergänzung",
      "subscription_data_change": "Abonnement: Datenänderung",
      "unlock_instructions": "Entsperrung",
      "unlock_notification": "Freischaltungshinweis",
      "unlock_reminder": "Erinnerung: ausstehende Freischaltung",
      "upload_approval_started_notification": "Legitimierungsprozess gestartet",
      "upload_editable_notification": "Informationsübermittlung wieder im Status Entwurf",
      "upload_in_review_notification": "Informationsübermittlung wurde übermittelt",
      "upload_ready_to_approve_notification": "Legitimierung kann gestartet werden",
      "upload_ready_to_review_notification": "Legitimierung wurde abgeschlossen",
      "upload_review_completeness_complete": "Formale Vollständigkeit festgestellt",
      "upload_review_plausibility_complete": "Inhaltliche Vollständigkeit festgestellt",
      "user_personal_data_notification": "Hinweis zur Änderung der persönlichen Daten"
    },
    "email_error": "Die E-Mail hat das falsche Format",
    "email_regex": "\\A[\\w\\-.]+@[a-z\\d]+((\\.|\\-)[a-z\\d]+)*\\.[a-z]+\\z",
    "email_reset": {
      "subject": "E-Mail-Änderungsanforderung",
      "text": "<p>Bitte bestätigen Sie Ihre neue E-Mail-Adresse, indem Sie auf den folgenden Link klicken</p>\n<p>%{link}</p>\n"
    },
    "error_page": {
      "forbidden": {
        "head_line": "Zugriff nicht gestattet (403)"
      },
      "head_line": "Entschuldigung!",
      "internal_error": {
        "head_line": "Leider ist etwas schiefgelaufen. (500)"
      },
      "not_found": {
        "head_line": "Dokument nicht gefunden (404)",
        "paragraph1": "Leider konnte das von Ihnen gewünschte Dokument nicht gefunden werden.",
        "paragtaph2": "Möglicherweise wurde es inzwischen vom Server entfernt oder ist nicht mehr abrufbar."
      },
      "sitename": "Fehlerseite",
      "unacceptable": {
        "head_line": "Leider ist etwas schiefgelaufen. (422)"
      }
    },
    "errors": {
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "already_confirmed": "wurde bereits bestätigt, bitte versuchen Sie, sich anzumelden",
        "blank": "muss ausgefüllt werden",
        "carrierwave_download_error": "konnte nicht heruntergeladen werden",
        "carrierwave_integrity_error": "ist kein zulässiger Dateityp",
        "carrierwave_processing_error": "konnte nicht verarbeitet werden",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "confirmation_period_expired": "musste innerhalb von %{period} bestätigt werden, bitte neu anfordern.",
        "content_type_allowlist_error": "Der Dateityp %{content_type} ist nicht erlaubt. Erlaubte Dateitypen: %{allowed_types}",
        "content_type_denylist_error": "Der Dateityp %{content_type} ist nicht erlaubt",
        "deletion_mail_error": "Konto nicht gültig",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "expired": "ist abgelaufen, bitte neu anfordern",
        "extension_allowlist_error": "Der Dateityp %{extension} ist nicht erlaubt. Erlaubte Dateitypen: %{allowed_types}",
        "extension_denylist_error": "Der Dateityp %{extension} ist nicht erlaubt. Verbotene Dateitypen: %{prohibited_types}",
        "extension_whitelist_error": "- Dieser Dateityp wird nicht akzeptiert. Erlaubte Dateitypen sind: %{allowed_types}",
        "generic_error": "Der Vorgang konnte nicht abgeschlossen werden!",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "max_size_error": "- Die Dateigröße darf nicht größer als %{max_size} sein",
        "min_size_error": "Die Dateigröße muss größer als %{min_size} sein",
        "model_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "not_found": "nicht gefunden",
        "not_locked": "ist nicht gesperrt",
        "not_saved": {
          "one": "%{resource} konnte aufgrund eines Fehlers nicht gespeichert werden:",
          "other": "%{count} Fehler verhinderten das Speichern von %{resource}:"
        },
        "odd": "muss ungerade sein",
        "other_than": "darf nicht gleich %{count} sein",
        "present": "darf nicht ausgefüllt werden",
        "processing_error": "Die Datei konnte nicht verarbeitet werden. Möglicherweise handelt es sich nicht um ein Bild",
        "required": "muss ausgefüllt werden",
        "taken": "ist bereits vergeben",
        "too_long": {
          "one": "ist zu lang (mehr als 1 Zeichen)",
          "other": "ist zu lang (mehr als %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (weniger als 1 Zeichen)",
          "other": "ist zu kurz (weniger als %{count} Zeichen)"
        },
        "wrong_length": {
          "one": "hat die falsche Länge (muss genau 1 Zeichen haben)",
          "other": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "form_type": {
      "addition": "addition",
      "annotation": "annotation",
      "upload": "upload"
    },
    "forms": {
      "description": "Formular für %{form_type} im Verfahren %{name} - Version %{version}",
      "fallback": "Keine Formulare vorhanden",
      "form_type": {
        "addition": "Ergänzungen",
        "upload": "Übertragungen"
      },
      "headline": "Formularübersicht",
      "import_137h_addition": "Neues Ergänzungsformular für Verfahren 137h importieren",
      "import_137h_upload": "Neues Übertragungsformular für Verfahren 137h importieren",
      "success": "Import erfolgreich!",
      "success_text": "Es wurde ein neues Formular mit der Version %{version} für %{form_type} im Verfahren %{name} importiert."
    },
    "help_text_name": {
      "approval_process": "Legitimierung",
      "attachment_file": "Anhang",
      "attachment_title": "Titel",
      "attachments": "Anhänge",
      "confirm_delete_attachment": "Anhang wirklich löschen?",
      "confirm_delete_link": "Link wirklich löschen?",
      "data_change": "Datenänderung",
      "delete": "Löschen",
      "delete_attachment_error": "Der Anhang konnte nicht gelöscht werden",
      "description": "Beschreibung",
      "edit": "Bearbeiten",
      "edit_attachment": "Anhang bearbeiten",
      "edit_ris_attachment": "Anhang austauschen",
      "internal_user_creation": "Neuer Mitarbeiter",
      "link_title": "Titel",
      "link_title_hint": "Wird als Link-Text angezeigt",
      "links": "Links",
      "login": "Anmeldung",
      "new_attachment": "Neuer Anhang",
      "new_link": "Neuer Link",
      "new_ris_attachment": "Neuer Ris-Anhang",
      "no_attachments": "Keine Anhänge vorhanden",
      "no_links": "Keine Links vorhanden",
      "registration_step_1": "Schritt 1 Registrierung",
      "registration_step_2": "Schritt 2 Registrierung",
      "registration_step_3": "Schritt 3 Registrierung",
      "review_attachment": "Anhang prüfen",
      "show": "Anzeigen",
      "upload_error": "Der Anhang konnte nicht hochgeladen werden",
      "upload_step_1": "Schritt 1 Übermittlung",
      "upload_step_2": "Schritt 2 Übermittlung",
      "url": "URL",
      "url_hint": "Eingabe ohne 'http://'"
    },
    "helpers": {
      "select": {
        "prompt": "Bitte wählen"
      },
      "submit": {
        "create": "%{model} erstellen",
        "submit": "%{model} speichern",
        "update": "%{model} aktualisieren"
      }
    },
    "icons": {
      "arrow_asc": "M.3 4.3c.3-.4 4.1-4 4.1-4 .1-.2.4-.3.6-.3.2 0 .5.1.7.3 0 0 3.7 3.6 4.1 4 .3.4.4 1 0 1.4-.5.4-1.4.3-1.4.3H1.6s-1 .1-1.4-.3-.3-1.1.1-1.4",
      "arrow_bottom_top1": "M1.6 58.7c2-2.1 23.5-22.5 23.5-22.5 1-1.1 2.5-1.7 3.9-1.7s2.9.6 3.9 1.7c0 0 21.4 20.4 23.5 22.5 2 2.1 2.2 5.8 0 8.1-2.2 2.2-5.2 2.4-7.9 0L29 48 9.5 66.8c-2.7 2.4-5.7 2.2-7.9 0-2.2-2.3-2.1-6 0-8.1",
      "arrow_bottom_top2": "M1.6 24.2c2-2.1 23.5-22.5 23.5-22.5C26.2.6 27.6 0 29 0s2.9.6 3.9 1.7c0 0 21.4 20.4 23.5 22.5 2 2.1 2.2 5.8 0 8.1-2.2 2.2-5.2 2.4-7.9 0L29 13.5 9.5 32.2c-2.7 2.4-5.7 2.2-7.9 0s-2.1-5.9 0-8",
      "arrow_desc": "M.3 9.7c-.4-.4-.4-1 0-1.4.4-.4 1.3-.3 1.3-.3h6.7s1-.1 1.4.3c.4.4.3 1.1 0 1.4-.4.4-4.1 4-4.1 4-.1.2-.4.3-.6.3-.2 0-.5-.1-.7-.3 0 0-3.7-3.6-4-4",
      "arrow_left": "M25 1.6c-2.1 2-22.5 23.5-22.5 23.5C1.4 26.2.8 27.6.8 29s.6 2.9 1.7 3.9c0 0 20.4 21.4 22.5 23.5 2.1 2 5.8 2.2 8.1 0 2.2-2.2 2.4-5.2 0-7.9L14.2 29 33 9.5c2.4-2.7 2.2-5.7 0-7.9s-6-2.1-8 0",
      "arrow_right": "M10 1.6c2.1 2 22.5 23.5 22.5 23.5 1.1 1.1 1.7 2.5 1.7 3.9s-.6 2.9-1.7 3.9c0 0-20.4 21.4-22.5 23.5-2.1 2-5.8 2.2-8.1 0-2.2-2.2-2.4-5.2 0-7.9L20.8 29 2 9.5C-.4 6.8-.2 3.8 2 1.6s6-2.1 8 0",
      "indicator_begin": "M274.998,4.582l-99.996,66.34c-13.752,9.117-36.252,9.117-50.004,0L25.002,4.582C11.25-4.535,0,1.5,0,18v120  h300V18C300,1.5,288.75-4.535,274.998,4.582z",
      "indicator_end": "M0,20.496c0,16.5,11.25,37.465,25.002,46.582l99.996,66.34c13.752,9.117,36.252,9.117,50.004,0l99.996-66.34  C288.75,57.961,300,36.996,300,20.496V0H0V20.496z",
      "magnifier": "M17.9 16.5c1.4-1.7 2.3-3.9 2.3-6.4C20.2 4.6 15.7 0 10.1 0S0 4.6 0 10.1s4.6 10.1 10.1 10.1c2.4 0 4.7-.8 6.4-2.3l9.1 9.1 1.4-1.4-9.1-9.1zm-7.8 1.7c-4.4 0-8.1-3.6-8.1-8.1S5.7 2 10.1 2s8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1z"
    },
    "incomplete": {
      "link_text": "Bearbeitung starten",
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab formale Unvollständigkeit",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang zunächst auf formale Vollständigkeit geprüft. Im Ergebnis der Prüfung auf formale Vollständigkeit fehlt es für die Veröffentlichung der Eingangsbestätigung an Informationen, die Sie dem beigefügten Schreiben entnehmen können. Ihre Informationsübermittlung steht Ihnen im Portal 137h wieder zur Bearbeitung zur Verfügung:</p>\n<p>%{link}</p>\n%{free_text}\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "internal_user_password_instruction": {
      "link_text": "Erstanmeldung",
      "subject": "Portal 137h | Bitte neues persönliches Nutzerkonto bestätigen",
      "success": "Der Nutzer wurde erfolgreich erstellt",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> im Portal 137h wurde ein Nutzerkonto für Ihre E-Mail-Adresse angelegt. Bitte klicken Sie auf den nachfolgenden Link \"Erstanmeldung\" um ein Passwort zu vergeben und das Benutzerkonto damit freizuschalten.</p>\n<p> %{link} </p>\n<p> Vielen Dank </p>\n"
    },
    "js_email_regex": "^[\\w\\-.]+@[a-z\\d]+((\\.|\\-)[a-z\\d]+)*\\.[a-z]+$",
    "lists": {
      "seperator": ": "
    },
    "loading_spinner": {
      "pdf_loading": "PDF wird erstellt..."
    },
    "mail_footer": {
      "city": "D-10587 Berlin",
      "email": "E-Mail: bewertung137h@g-ba.de",
      "name": "Gemeinsamer Bundesausschuss",
      "platform": "Portal: %{portal_link}",
      "street": "Gutenbergstraße 13",
      "tel": "Tel.: +49 30 275838-0",
      "website": {
        "identifier": "Website: ",
        "link": "https://www.g-ba.de"
      }
    },
    "manufacturer_invite": {
      "link_text": "Registrieren und Bearbeitung starten",
      "subject": "Portal 137h | Einladung zur gemeinsamen Bearbeitung der Informationsübermittlung",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>ein Krankenhaus hat über das Portal 137h zur digitalen Informationsübermittlung an den Gemeinsamen Bundesausschuss im Rahmen von Bewertungsverfahren nach § 137h SGB V eine Informationsübermittlung zu einer neuen Untersuchungs- oder Behandlungsmethode mit einem Medizinprodukt hoher Risikoklasse gestartet. Das Krankenhaus lädt Sie hiermit als betroffenen Medizinproduktehersteller eines Medizinprodukts hoher Risikoklasse, auf dessen Einsatz die technische Anwendung der betreffenden Methode maßgeblich beruht, zur gemeinsamen Bearbeitung der Informationsübermittlung ein. Bitte klicken Sie auf den nachfolgenden Link, um sich zu registrieren (sofern nicht bereits erfolgt) und die Bearbeitung durch den Medizinproduktehersteller zu starten. </p>\n<p>%{link}</p>\n</ p>\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "meta_data": {
      "begin_annotation": "Beginn Informationsergänzung",
      "begin_assessment": "Beginn des Bewertungsverfahrens",
      "editor_ref": "Bearbeiter/in REF",
      "editor_ref_rep": "Bearbeiter/in REF Vertretung",
      "editor_sb": "Bearbeiter/in SB",
      "editor_sb_rep": "Bearbeiter/in SB Vertretung",
      "end_annotation": "Ende Informationsergänzung",
      "end_assessment": "Ende des Bewertungsverfahrens",
      "gba_link": "Link zum Bewertungsverfahren auf g-ba.de",
      "indication": "Indikation",
      "institution": "Institution",
      "intervention": "Intervention",
      "process_code": "Vorgangsnummer",
      "publishing_comment": "Veröffentlichungskommentar",
      "title": "Methodenbezeichnung (Titel)"
    },
    "method_already_existing": {
      "subject": "Ihre Informationsübermittlung an den G-BA",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>wir haben eine Informationsübermittlung Ihres Krankenhauses gemäß § 137h Absatz 1 SGB V erhalten. Bitte beachten Sie das beigefügte Anschreiben im Anhang dieser E-Mail.</p>\n%{free_text}\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "monitoring": {
      "text": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.\nUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.\nNam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.\nAt vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.\nConsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus.\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.\nUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.\nNam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.\nAt vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.\nConsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus.\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.\nUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.\n"
    },
    "new_annotation_notification": {
      "link_text": "Zur Informationsergänzung",
      "subject": "Portal 137h | Neue Informationsergänzung",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> es ist eine neue Informationsergänzung gemäß dem 2. Kapitel § 35 VerfO über das Portal 137h eingegangen. Klicken Sie auf den untenstehenden Link, um die Informationsergänzung einzusehen. </p>\n<p>%{link}</p>\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "new_internal": {
      "city": "Berlin",
      "confirm_password": "Passwort bestätigen",
      "create": "Anlegen",
      "create_password": "Passwort erstellen",
      "headline": "Neuen internen Mitarbeiter anlegen",
      "institution_sector": "Gemeinsamer Bundesausschuss",
      "password": "Password",
      "phone": "+49 30 275838-0",
      "required": "* Pflichtfeld",
      "role": "Rolle",
      "street": "Gutenbergstraße 13",
      "submit": "Nutzer anlegen",
      "website": "www.g-ba.de",
      "zip": "10587"
    },
    "new_upload_notification": {
      "link_text": "Zur Prüfung",
      "subject": "Portal 137h | Neue Informationsübermittlung",
      "text": "<p>Liebe Kollegin, lieber Kollege, </p>\n<p>es ist eine neue Informationsübermittlung nach § 137h Absatz 1 SGB V über das Portal 137h eingegangen. Bitte leiten Sie die Prüfung durch die Geschäftsstelle und die nächsten Schritte durch Klicken auf den unten stehenden Link ein. </p>\n<p>%{link} </p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": {
              "one": "Milliarde",
              "other": "Milliarden"
            },
            "million": {
              "one": "Million",
              "other": "Millionen"
            },
            "quadrillion": {
              "one": "Billiarde",
              "other": "Billiarden"
            },
            "thousand": "Tausend",
            "trillion": {
              "one": "Billion",
              "other": "Billionen"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "pagination": {
      "gap": "...",
      "next_arrow": "<svg viewBox=\"0 0 34.2 58\"><path fill=\"#a4a4a4\" d=\"M10 1.6c2.1 2 22.5 23.5 22.5 23.5 1.1 1.1 1.7 2.5 1.7 3.9s-.6 2.9-1.7 3.9c0 0-20.4 21.4-22.5 23.5-2.1 2-5.8 2.2-8.1 0-2.2-2.2-2.4-5.2 0-7.9L20.8 29 2 9.5C-.4 6.8-.2 3.8 2 1.6s6-2.1 8 0\"></path></svg>",
      "prev_arrow": "<svg viewBox=\"0 0 35 58\"><path fill=\"#A4A4A4\" fill-rule=\"nonzero\" d=\"M25 1.6c-2.1 2-22.5 23.5-22.5 23.5C1.4 26.2.8 27.6.8 29s.6 2.9 1.7 3.9c0 0 20.4 21.4 22.5 23.5 2.1 2 5.8 2.2 8.1 0 2.2-2.2 2.4-5.2 0-7.9L14.2 29 33 9.5c2.4-2.7 2.2-5.7 0-7.9s-6-2.1-8 0\"></path></svg>"
    },
    "password_confirmation_error": "Passwort stimmt nicht mit Passwortbestätigung überein",
    "password_error": "mindestens 6 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe und eine Ziffer",
    "password_regex": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{6,}",
    "personal_data_reminder": {
      "subject": "Ein Benutzer wartet seit 12 Stunden auf die Aktualisierung seiner persönlichen Daten",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> im Portal 137h hat eine Nutzerin oder ein Nutzer ihre bzw. seine persönlichen Daten im Benutzerkonto vor 12 Stunden geändert. Klicken Sie auf den nachfolgenden Link, um die geänderten Daten auf Plausibilität zu prüfen und das Benutzerkonto, sofern die Angaben plausibel sind, freizuschalten. Erst wenn das Benutzerkonto freigeschaltet ist, kann die Nutzerin oder der Nutzer die Änderungen sehen. Die Freigabe des Benutzerkontos sollte innerhalb von 24 Stunden eines Werktages erfolgen (das Wochenende zählt nicht mit).</p>\n<p> %{link} </p>\n"
    },
    "project_title": "Portal 137h",
    "publishing_comment": {
      "description": "Das Informationsergänzungsverfahren wurde gestartet. Sie können hier einen Hinweis zur Veröffentlichung des Verfahrens angeben.",
      "footnote": "* Der Hinweis ist optional",
      "headline": "Hinweis zur Veröffentlichung",
      "save": "Speichern und veröffentlichen",
      "sitename": "Hinweis zur Veröffentlichung"
    },
    "registration_hint": {
      "headline": "Hinweis",
      "hint_text": "Herzlichen Dank für die Registrierung Ihres Benutzerkontos im Portal 137h. Sie erhalten in Kürze eine E-Mail mit einem Link zur Bestätigung Ihrer E-Mail-Adresse. Sobald Sie den Link betätigt haben, prüft die Geschäftsstelle des G-BA Ihre angegebenen Benutzerdaten auf Plausibilität und schaltet Ihr Benutzerkonto frei, wenn die Angaben plausibel sind. Die Freigabe des Benutzerkontos sollte innerhalb von einem Werktag erfolgen (das Wochenende zählt nicht mit). Danach können Sie Ihr Benutzerkonto verwenden.",
      "sitename": "Registrierungshinweis"
    },
    "registration_notification": {
      "subject": "Ein neuer Nutzer hat sich registriert",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> im Portal 137h ist eine Registrierung für ein neues Benutzerkonto eingegangen. Die E-Mail-Adresse wurde per Betätigung des versandten Links bestätigt. </p>\n<p> Bitte prüfen Sie die angegebenen Benutzerdaten auf Plausibilität durch Klicken auf den unteren Link und schalten Sie das Benutzerkonto frei, wenn die Angaben plausibel sind. Erst dann kann die Nutzerin oder der Nutzer das Benutzerkonto verwenden. Die Freigabe des Benutzerkontos sollte innerhalb von einem Werktag erfolgen (das Wochenende zählt nicht mit). </p>\n<p> %{link} </p>\n"
    },
    "registrations": {
      "new": {
        "back": "Zurück",
        "headline": "Registrierung",
        "next": "Weiter",
        "submit": "Registrierung abschließen"
      },
      "step_one": {
        "required": "* Pflichtfelder",
        "title": "Persönliche Daten"
      },
      "step_three": {
        "title": "Zusammenfassung"
      },
      "step_two": {
        "privacy_policy": "Datenschutzerklärung",
        "privacy_policy_checkbox": "Ja, ich habe die Datenschutzerklärung gelesen!",
        "privacy_policy_text": "<div style=\"padding: 5px\">\n  <h3>Verantwortliche Stelle</h3>\n  Für die Nutzung der Website gilt die folgende Datenschutzerklärung. Diese Website ist ein Angebot des Gemeinsamer Bundesausschuss, Gutenbergstraße 13, 10587 Berlin (nachfolgend „G-BA“).\n  <h3>Erhebung, Verarbeitung und Nutzung personenbezogener Daten</h3>\n  Jeder Zugriff auf das Internetangebot des G-BA sowie jeder Abruf einer Datei wird ausschließlich zum Zwecke der Abwehr und Verfolgung sicherheitsrelevanter Zugriffe auf das Angebot für einen begrenzten Zeitraum in einer Protokolldatei gespeichert und verarbeitet. Dabei werden folgende Angaben erfasst:\n  <ul>\n    <li>die genutzte IP-Adresse</li>\n    <li>die Adresse der Seite, auf der Sie sich beim Abruf befanden (http-Referer)</li>\n    <li>Name der aufgerufenen Website/der abgerufenen Datei</li>\n    <li>Datum, Uhrzeit der Anforderung</li>\n    <li>die übertragene Datenmenge</li>\n    <li>Meldung, ob der Zugriff/Abruf erfolgreich war.</li>\n  </ul>\n  </br>\n  Eine personenbezogene Auswertung der Server-Logfiles findet nicht statt. Diese Daten sind für uns zu keinem Zeitpunkt bestimmten oder bestimmbaren Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Rechtsgrundlage dafür ist <span style=\"white-space: nowrap\">Art. 6 Abs. 1 f DSGVO</span>.\n  Darüber hinaus werden Daten in anonymisierter Form für statistische Zwecke verwendet und ausgewertet. Die Daten sind nicht mehr personenbezogen verwertbar.\n  Bei folgenden interaktiven Services und Leistungen muss der G-BA personenbezogene Daten von Ihnen erheben, um Ihnen die gewünschten Leistungen zukommen lassen zu können bzw. Ihnen Zugang zu speziellen Angeboten zu verschaffen:\n  <ul>\n    <li> Kontakt/E-Mails/Anfragen allgemein</li>\n    <li> Abonnement von Benachrichtigungen</li>\n  </ul>\n  </br>\n  Die von Ihnen übermittelten Daten werden ausschließlich für den jeweiligen Zweck verwendet. Es werden nur die von Ihnen z. B. durch das Ausfüllen von der jeweiligen Formularmaske oder bei der Anforderung von Informationsmaterial übermittelten personenbezogenen Angaben erhoben.\n  Rechtsgrundlage dafür ist Ihre Einwilligung bzw. die Erfüllung Ihrer <span style=\"white-space: nowrap\">Anfrage, Art. 6 Abs. 1 a, b DSGVO</span>. Die Zusendung von Benachrichtigungen können Sie jederzeit über den jeweiligen Vorgang im geschützten Bereich des Portals abbestellen.\n  In allen anderen Fällen findet keinerlei Erhebung oder Verarbeitung Ihrer personenbezogenen Daten statt. Der G-BA erhebt nur diejenigen Daten, die benötigt werden, um den jeweiligen Dienst in Anspruch zu nehmen. Sollten Sie Ihre Einwilligung hierzu nicht erteilen wollen, bitten wir Sie um Verständnis, dass Sie die entsprechende Leistung nicht in Anspruch nehmen können.\n  Der G-BA gibt Ihre personenbezogenen Daten nicht an Dritte weiter.\n  Rechtsgrundlage dafür ist Ihre Einwilligung bzw. die Erfüllung Ihrer <span style=\"white-space: nowrap\">Anfrage, Art. 6 Abs. 1 a, b DSGVO</span>.\n  <br/>\n  <h3>Einsatz von Cookies</h3>\n  Im Rahmen Ihres Besuchs auf unseren Seiten verwenden wir sogenannte Cookies. Dabei handelt es sich um sehr geringe Datenmengen, die auf Ihrem Computer abgelegt und bei Seitenabrufen zurück an unseren Server übertragen werden. Cookies können auf Ihrem Rechner keinen Schaden anrichten und keine Viren enthalten. Die in sogenannten „Permanent-Cookies“ gespeicherten Daten bleiben über Ihren aktuellen Besuch hinaus gespeichert und dienen uns ausschließlich zur statistischen Auswertung unseres Angebots (z. B. Erstellung von Statistiken über Besucherzahlen). Rückschlüsse auf Ihre Person sind aus diesen Cookies und Statistiken nicht möglich. Wenn Sie keine Permanent-Cookies zulassen möchten, können Sie dies durch eine Deaktivierung von permanenten Cookies in Ihrem Browser vornehmen (Details zum Vorgehen entnehmen Sie bitte der Hilfe-Funktion in der Menüleiste Ihres Browsers). Die Deaktivierung hat keinen Einfluss auf die Nutzbarkeit unserer Seite.\n  <br/>\n  Die in sogenannten „Session-Cookies“ abgelegten Daten gelten nur für Ihren jeweils aktuellen Besuch auf unseren Internetseiten. Auch diese Cookies werden zu statistischen Zwecken ohne Personenbezug eingesetzt. Sie sind des Weiteren aus technischen Gründen notwendig, wenn Sie Login-basierte Anwendungen wie das G-BA-Extranet oder die Meldung der Fallzahlen zur Erhebung des Systemzuschlags nutzen möchten. Diese Anwendungen können daher nicht genutzt werden, wenn Session Cookies im Browser deaktiviert sind. Session-Cookies werden bei Beendigung der Internet-Sitzung automatisch wieder von Ihrem Rechner entfernt.\n  Rechtsgrundlage dafür ist unser berechtigte Interesse iSd <span style=\"white-space: nowrap\">Art. 6 Abs. 1 f DSGVO</span>.\n  <h3>Sichere Datenübertragung</h3>\n  Der G-BA stellt die Einhaltung von angemessenen technischen und organisatorischen Sicherheitsmaßnahmen sicher, die dem Stand der Technik entsprechen, um den datenschutzrechtlichen Anforderungen Rechnung zu tragen. Insbesondere werden die von Ihnen zur Verfügung gestellten personenbezogenen Daten durch zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder Zugriff unberechtigter Personen geschützt.\n  </br>\n  Der Zugriff auf Ihre personenbezogenen Daten ist nur wenigen besonders befugten Personen möglich, die mit der technischen oder redaktionellen Betreuung der Server oder Ihrer gestellten Anfrage befasst sind.\n  <br/>\n  Ihre persönlichen Daten werden bei uns sicher durch Verschlüsselung übertragen. Dies gilt für das Login und auch die Nutzung der oben genannten Portale. Wir bedienen uns dabei des Codierungssystems SSL (Secure Socket Layer). Zwar kann niemand einen absoluten Schutz garantieren. Wir sichern unsere Webseiten und sonstige Systeme jedoch durch technische und organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung Ihrer Daten durch unbefugte Personen ab.\n  <h3>Dauer der Datenspeicherung / Löschung der Daten</h3>\n  Personenbezogene Daten, die uns über unsere Webseite mitgeteilt worden sind, werden nur so lange gespeichert, bis der jeweilige Zweck, zu dem sie uns anvertraut wurden, erfüllt ist. Dies gilt auch für personenbezogene Daten, für die Sie Ihre Einwilligung erteilt haben, es sei denn, es stehen keine anderweitigen gesetzlichen Verpflichtungen entgegen. Nach Wegfall des Verwendungszwecks werden Ihre personenbezogenen Daten vollständig gelöscht.\n  <br/>\n  IP-Adressen speichern wir über einen Zeitraum von maximal vierzehn Tagen. Die Speicherung erfolgt aus Gründen der Datensicherheit, um die Stabilität und die Betriebssicherheit unseres Systems zu gewährleisten.\n  <h3>Rechte und Beschwerdemöglichkeiten</h3>\n  Sie haben uns gegenüber folgende Rechte hinsichtlich der Sie betreffenden Daten:\n  <ul style=\"padding-bottom: 15px\">\n    <li>Recht auf Auskunft</li>\n    <li>Recht auf Berichtigung oder Löschung</li>\n    <li>Recht auf Einschränkung der Verarbeitung</li>\n    <li>Recht auf Widerruf Ihrer Einwilligung</li>\n    <li>Recht auf Widerspruch gegen die Verarbeitung</li>\n  </ul>\n  Sie können sämtliche dieser Rechte geltend machen, indem Sie sich an unseren Datenschutzbeauftragten wenden:\n  <div class=\"spaced\">\n    <i>persönlich / vertraulich</i>\n    <br/>\n    Gemeinsamer Bundesausschuss\n    <br/>\n    – Datenschutzbeauftragter –\n    <br/>\n    Gutenbergstraße 13\n    <br/>\n    10587 Berlin\n  </div>\n  <div class=\"spaced\">\n    oder\n  </div>\n  <div class=\"spaced\">\n    <a href=\"mailto:datenschutz@g-ba.de\">datenschutz@g-ba.de</a>\n  </div>\n  <br/>\n  Sie haben zudem das Recht, sich bei der zuständigen Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.\n</div>\n",
        "terms_checkbox": "Ja, ich habe die Nutzungsbedingungen gelesen!",
        "terms_of_service": "Nutzungsbedingungen",
        "terms_of_service_text": "<div style=\"padding: 5px\">\nAllgemeine Nutzungsbedingungen für das Portal 137h<br>\n(Stand: 1. September 2022)\n<h3>§\t1\tLeistungsumfang</h3>\nDer Gemeinsame Bundesausschuss (im Folgenden: G-BA) stellt den nach § 2 Nutzungsberechtigten eine Online-Anwendung über das Internet-Portal (https://portal137h.g-ba.de; im Folgenden: Portal 137h) zur Verfügung, mit der diese die in § 137h SGB V sowie im 8. Abschnitt des 2. Kapitels der Verfahrensordnung  des G-BA (im Folgenden: VerfO) für Krankenhäuser und betroffene Medizinproduktehersteller geregelten Verfahrenshandlungen zur Informationsübermittlung und Informationsergänzung nach § 137h SGB V auf elektronischem Wege vornehmen können. Sämtliche für diese Verfahrenshandlungen einzureichenden Unterlagen können dem G-BA über das Portal 137h auf elektronischem Wege übermittelt werden, sofern sie keine hoch vertraulichen Betriebs- und Geschäftsgeheimnisse enthalten.\n<h3>§\t2\tNutzungsberechtigte</h3>\nNutzungsberechtigt sind Krankenhäuser und Hersteller eines für die technische Anwendung einer Untersuchungs- und Behandlungsmethode maßgeblichen Medizinprodukts sowie etwaige von den Vorgenannten bevollmächtigte Personen oder Unternehmen.\n<h3>§\t3\tVoraussetzungen für die Nutzung der des Portals 137h</h3>\n(1)\tUm das Portal 137h nutzen zu können, müssen sich die Nutzer im Portal 137h registrieren und anmelden. Mit der Registrierung erhält der Nutzer die Möglichkeit, sich mit einem Benutzernamen und der Bestimmung eines Passworts im Portal 137h anzumelden. Mit der Anmeldung erhält der Nutzer Zugang in den zugangsgeschützten Bereich des Portals 137h.\n<br><br>\n(2)\tNutzungsberechtigte können Dritte zur Nutzung des Portals 137h bevollmächtigen. Sofern sie hierfür den Benutzernamen und das Passwort an die Bevollmächtigten weitergeben, obliegt dies der Eigenverantwortung des Vollmachtgebers. Der Vollmachtgeber ist für alle Handlungen verantwortlich, die unter seinem Benutzernamen und seinem Passwort vorgenommen werden.\n<br><br>\n(3)\tZur Erläuterung der Nutzungsmöglichkeiten werden im Portal 137h Verfahrensanleitungen und die Beschreibung von Besonderheiten der Anwendung des Portals 137h zur Verfügung gestellt.\n<h3>§\t4\tRechtswirksame Ausübung von Verfahrenshandlungen über das Portal 137h</h3>\nDie rechtswirksame Übermittlung von Informationen nach § 137h SGB V setzt voraus, dass die zur Vornahme einer Informationsübermittlung eingereichten Formularabschnitte mit qualifizierten elektronischen Signaturen im Sinne des Signaturgesetzes versehen sind. Der Nutzer erhält über den Eingang der Informationsübermittlung beim G-BA eine Bestätigung per E-Mail; die Frage der Vollständigkeit der Informationsübermittlung bleibt hiervon unberührt.\n<h3>§\t5\tÄnderung des Passwortes </h3>\nDer Nutzer ist berechtigt, sein Passwort eigenverantwortlich jederzeit zu ändern. Bei Änderung des Passwortes wird das bisherige Passwort ungültig.\n<h3>§\t6\tVerfügbarkeit des Portals 137h</h3>\n(1)\tDas Portal 137h kann jederzeit genutzt werden.\n<br><br>\n(2)\tStörungen in der Nutzung des Portals 137h sollten Nutzer dem G-BA wenn möglich unverzüglich, d.h. noch am selben Tag, an dem die Störung festgestellt wurde, mitteilen (Telefon: 030-275838-0, Email: bewertung137h@g-ba.de). Im Fall einer Störungsmeldung an demselben Tag der Störung des Portalbetriebs kann der Nutzer die Verfahrenshandlung bis 13 Uhr des folgenden Werktags (grundsätzlich Montag bis Freitag, soweit es sich nicht um einen im Bundesland Berlin geltenden Feiertag handelt) vornehmen. Die alternativen Möglichkeiten zur Vornahme von Verfahrenshandlungen z.B. per Email, Post oder Kurier bleiben unberührt.\n<h3>§\t7\tSperrung des Zugangs zum Portal 137h</h3>\nBei Verdacht eines Missbrauches oder auf Aufforderung des Nutzers wird der Zugang zum Portal 137h unverzüglich innerhalb der Geschäftszeiten der Geschäftsstelle gesperrt.\n<h3>§\t8\tSorgfalts- und Mitwirkungspflichten des Nutzers</h3>\n(1)\tDer Nutzer hat dafür Sorge zu tragen, dass keine unbefugte Person Kenntnis von dem Benutzernamen und dem Passwort erlangt. Insbesondere dürfen Benutzernamen und Passwort nicht ungeschützt auf einem Computer abgelegt werden. Jede Person, die Zugriff auf Benutzernamen und Passwort erlangt, hat die Möglichkeit, das Portal 137h des G-BA zu nutzen. Stellt der Nutzer fest, dass eine unbefugte Person von dem Benutzernamen und dem Passwort Kenntnis erlangt hat, ist er verpflichtet, unverzüglich sein Passwort zu ändern oder den Zugang sperren zu lassen. Sofern ihm dies nicht möglich ist, hat er den G-BA unverzüglich zu benachrichtigen und diesen zur Sperrung nach § 7 aufzufordern.\n<br><br>\n(2)\tDa Angriffe auf die Sicherheit des Systems des Portals 137h möglich sind, hat der Nutzer im eigenen Interesse die zur Abwehr dieser Gefahren erforderlichen Maßnahmen zu treffen und seinen Rechner von allen Programmen freizuhalten, die die Sicherheit gefährden können (z. B. Computerviren einschließlich sog. Trojaner). Hierbei können ihn handelsübliche Virenschutzprogramme unterstützen. Der Nutzer hat sich darüber zu informieren, dass der von ihm verwendete Browser keine Sicherheitsmängel aufweist und regelmäßig die Sicherheitsbelange des von ihm verwendeten Systems (Betriebssystem, Browser etc.) zu überprüfen, um eine Gefährdung des Systems des Portals 137h zu verhindern. Der Nutzer hat Maßnahmen zu ergreifen, die die Systemsicherheit erhöhen, z. B. Installation von Programm-Aktualisierungen, die der Sicherheit dienen.\n<br><br>\n(3)\tBei Erscheinen des Begrüßungsbildschirms des Portals 137h  hat sich der Nutzer zunächst zu vergewissern, dass er tatsächlich mit dem Portal 137h des G-BA in Kontakt steht. Diese Prüfung erfolgt durch die Beachtung der korrekten Adresse in der Adresszeile des eingesetzten Webbrowsers und Kontrolle des für die Verbindung an den Browser übermittelten Serverzertifikats auf Gültigkeit und Plausibilität. Andernfalls besteht die Gefahr, dass Dritte auf diesem Weg Kenntnis von dem Benutzernamen und dem Passwort erlangen; hiermit verbunden wäre zugleich die Gefahr einer Übermittlung unzutreffender Informationen oder einer Änderung bereits übermittelter Informationen durch unbefugte Dritte. Der Nutzer hat alle von ihm eingegebenen Daten auf Vollständigkeit und Richtigkeit zu überprüfen. Fehlerhafte Angaben können direkte Auswirkungen auf den Inhalt und die Rechtswirksamkeit von Verfahrenshandlungen sowie auf die Bewertung nach § 137h SGB V zur Folge haben.\n<br><br>\n(4)\tKrankenhäuser und betroffene Medizinproduktehersteller haben dafür Sorge zu tragen, dass die in den Absätzen 1 bis 3 aufgeführten Sorgfalts- und Mitwirkungspflichten des Nutzers den Bevollmächtigten bekannt gemacht sind, denen sie die Nutzung des Portals 137h übertragen wollen.\n<h3>§\t9\tHaftung</h3>\n(1)\tEs gelten die unter www.g-ba.de veröffentlichten \"Erklärungen zum Internetangebot, zur Haftung, zu Links und Verlinkung“.\n<br><br>\n(2)\tEine Haftung des G-BA für Schäden aus einer unberechtigten, missbräuchlichen oder unkorrekten Verwendung des Benutzernamens und des Passworts des Nutzers oder aus einer Nutzung des Portals 137h unter Verstoß gegen die Nutzungsbedingungen oder für sonstige Schäden, gleich woraus sie resultieren, ist ausgeschlossen. Dies gilt nicht für Schäden, die auf grober Fahrlässigkeit oder Vorsatz des G-BA beruhen. Der Schadenersatz ist jedoch auf den vorhersehbaren vertragstypischen Schaden begrenzt.\n<br><br>\n(3)\tDer G-BA übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Verfahrensanleitungen und Beschreibungen der Besonderheiten der Anwendung des Portals 137h. Der G-BA haftet nicht für Abweichungen der abrufbaren Inhalte von Informationsübermittlungsformularen, die für das Informationsergänzungsverfahren für die Webseite des Portals 137h erstellt wurden, sowie für unbefugte Veränderung der Angaben auf dem Server durch Dritte, soweit diese nicht auf grobem Verschulden des G-BA beruhen. Soweit auf Gesetze und Verordnungen und sonstige Regelungen Bezug genommen oder diese wiedergegeben werden, ist allein deren amtliche Bekanntmachung maßgeblich. Der Abruf von Inhalten einschließlich eventueller inhaltlicher oder technischer Fehler erfolgt auf eigene Gefahr des Nutzers. Haftungsansprüche gegen den G-BA, welche sich auf Schäden materieller oder immaterieller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen oder durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind ausgeschlossen, sofern seitens des G-BA kein grobes Verschulden vorliegt. Hinweise und Informationen des G-BA für Nutzer lassen deren rechtliche Verantwortlichkeit unberührt.\n<br><br>\n(4) Der G-BA behält es sich vor, das Angebot des Portals 137h ganz oder in Teilen ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen. Soweit infolge einer solchen Veränderung die Einhaltung einer Verfahrensfrist unmöglich wurde, gilt bei unverzüglicher Anzeige dieses Sachverhalts und Übermittlung der Informationen auf dem herkömmlichen Übermittlungswege die Frist dennoch als gewahrt.\n<h3>§\t10\tDatenschutzerklärung</h3>\nEs gelten die unter www.g-ba.de – Impressum und Datenschutz abrufbaren \"Erklärungen zum Internetangebot, zur Haftung, zu Links und Verlinkung, zum Urheberrecht und Datenschutz\" sowie die gesonderte Datenschutzerklärung zur Nutzung des Portals 137h.\n</div>\n"
      }
    },
    "reject": {
      "description": "Bitte geben Sie einen Ablehnungsgrund ein:",
      "required": "* Pflichtfeld",
      "sitename": "Ablehnungsgrund"
    },
    "reminder": {
      "subject": "Ein Nutzer wartet seit 12 Stunden auf seine Freischaltung",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p> im Portal 137h ist eine Registrierung für ein neues Benutzerkonto eingegangen. Die E-Mail-Adresse wurde per Betätigung des versandten Links vor 12 Stunden bestätigt. </p>\n<p> Bitte prüfen Sie die angegebenen Benutzerdaten auf Plausibilität durch klicken auf den unteren Link und schalten Sie das Benutzerkonto frei, sofern die Angaben plausibel sind. Erst dann kann die Nutzerin oder der Nutzer das Benutzerkonto verwenden. Die Freigabe des Benutzerkontos sollte innerhalb von einem Werktag erfolgen (das Wochenende zählt nicht mit). </p>\n<p> %{link} </p>\n"
    },
    "reset_password": {
      "new_password": "Neues Passwort",
      "text": "<p> Sehr geehrte Damen und Herren,</p>\n<p> über das Portal für Informationsübermittlung und -ergänzung im Rahmen von Bewertungsverfahren nach § 137h SGB V des Gemeinsamen Bundesausschusses wurde unter Verwendung Ihrer E-Mail-Adresse die Vergabe eines neuen Passworts für Ihr Nutzerkonto angefordert. Um Ihr Passwort neu zu vergeben, wählen Sie bitte \"Neues Passwort\" (Link ist 24 Stunden gültig).</p>\n<p>%{link}</p>\n<p> Sollten Sie die Anforderung nicht selber ausgelöst und auch nicht autorisiert haben, betätigen Sie den Link nicht. Er verfällt automatisch nach Ablauf der angegebenen Zeitspanne.</p>\n<p> Diese Nachricht wurde automatisch generiert.</p>\n<p> Mit freundlichen Grüßen </p>\n"
    },
    "ris_attachments": {
      "confirm_delete": "Datei wirklich löschen?",
      "delete": {
        "link": "Löschen",
        "success": "Datei gelöscht"
      },
      "edit": {
        "headline": "Gesamttreffer der Recherchen",
        "link": "Datei austauschen",
        "success": "Neue Datei erfolgreich gespeichert",
        "title": "Bitte wählen Sie eine Datei:"
      },
      "link_new": "Datei hinzufügen",
      "new": {
        "headline": "Gesamttreffer der Recherchen",
        "link": "Datei hinzufügen",
        "success": "Neue Datei erfolgreich gespeichert",
        "title": "Bitte wählen Sie eine Datei:"
      },
      "required": "* Pflichtfeld",
      "show": {
        "delete": "Löschen",
        "edit": "Austauschen",
        "headline": "Gesamttreffer der Recherchen"
      },
      "submit": "Speichern"
    },
    "ris_attributes": {
      "Abstract": "AB",
      "Autoren": "AU",
      "DOI": "DO",
      "Jahr": "PY",
      "PubMed": "PM",
      "Titel": "TI",
      "Typ": "TY"
    },
    "ris_tags": {
      "AB": "Abstract",
      "AU": "Autoren",
      "DO": "DOI",
      "PM": "PubMed",
      "PY": "Jahr",
      "T1": "Titel",
      "T2": "Titel",
      "TI": "Titel",
      "TY": "Typ"
    },
    "roles": {
      "groups": {
        "consultant": "Berater",
        "gba": "G-BA",
        "hospital": "Krankenhaus",
        "producer": "Medizinproduktehersteller"
      },
      "names": {
        "admin": "G-BA Admin",
        "consultant": "Berater für Krankenhaus oder Medizinproduktehersteller",
        "declined": "Deaktiviert",
        "deleted": "gelöscht",
        "hospital_user": "Krankenhausmitarbeiter",
        "monitoring": "Monitoring",
        "pending": "Warten auf Bestätigung",
        "producer": "Medizinproduktehersteller",
        "specialist": "G-BA Fachanwender",
        "test": "Test",
        "unconfirmed_email": "E-Mail nicht bestätigt"
      }
    },
    "salutation": {
      "mr": "Herr",
      "mrs": "Frau"
    },
    "sector": {
      "external": {
        "consultant": "Beratungsunternehmen",
        "hospital": "Krankenhaus",
        "medical_device_manufacturers": "Medizinprodukthersteller"
      },
      "internal": {
        "g-ba": "Gemeinsamer Bundesausschuss"
      }
    },
    "select_values": {
      "Typ": {
        "Bericht": "RPRT",
        "Buch": "BOOK",
        "Buch Kapitel": "CHAP",
        "Fachzeitschrift": "JOUR",
        "Konferenz": "CONF",
        "Nicht veröffentlichte Arbeit": "UNPB",
        "Patent": "PAT",
        "Sonstiges": "GEN",
        "Thesis/Dissertation": "THES"
      }
    },
    "small_shortage": {
      "link_text": "Bearbeitung starten",
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab Unvollständigkeit der übermittelten Informationen",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang und Feststellung der formalen Vollständigkeit auf Vollständigkeit geprüft. Im Ergebnis der Prüfung auf Vollständigkeit bestehen erhebliche Unvollständigkeiten der übermittelten Informationen. Der G-BA fordert daher Informationen gemäß dem 2. Kapitel § 34 Absatz 3 Satz 3 und 4 VerfO nach. Diese können Sie dem beigefügten Schreiben entnehmen. Ihre Informationsübermittlung steht Ihnen im Portal 137h wieder zur Bearbeitung zur Verfügung:</p>\n<p>%{link}</p>\n%{free_text}\n<p>Mit freundlichen Grüßen </p>\n"
    },
    "submenu": {
      "register": "Registrieren"
    },
    "subscription_annotation": {
      "subject": "Eine abonnierte Übermittlung wurde ergänzt",
      "text": "<p> Eine abonnierte Übermittlung wurde ergänzt</p>\n"
    },
    "subscription_data_change": {
      "subject": "Es wurden Daten geändert",
      "text": "<p> Es wurden Daten geändert</p>\n"
    },
    "support": {
      "array": {
        "last_word_connector": " und ",
        "two_words_connector": " und ",
        "words_connector": ", "
      }
    },
    "table": {
      "confirm_delete": "Wollen Sie den Eintrag wirklich löschen?",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "edit_entry": "Eintrag bearbeiten",
      "entry": {
        "many": "Einträge",
        "one": "Eintrag"
      },
      "new_entry": "Neuer Eintrag",
      "no_entries": " (Keine Einträge in der Tabelle vorhanden)",
      "required": "* Pflichtfelder",
      "ris_upload_error": "Ein Fehler ist aufgetreten. Überpürfen Sie, ob die Felder %{required} für jeden Literatureintrag belegt sind.",
      "site_name": "Tabelle pflegen",
      "submit": "Speichern",
      "table_as_pdf": "Vollständige Tabelle als PDF-Datei",
      "table_as_ris": "Literaturliste als RIS-Datei",
      "table_hint": "Die Tabelle wird eventuell nur in Teilen angezeigt. Zum vollständigen Betrachten öffnen Sie das PDF-Dokument.",
      "upload_ris": "ris-Datei hochladen"
    },
    "time": {
      "am": "vormittags",
      "formats": {
        "default": "%A, %d. %B %Y, %H:%M Uhr",
        "long": "%A, %d. %B %Y, %H:%M Uhr",
        "short": "%d. %B, %H:%M Uhr"
      },
      "pm": "nachmittags"
    },
    "unlock_notification": {
      "subject": "Ihr Nutzerkonto wurde freigeschaltet",
      "text": "<p> Sehr geehrte Damen und Herren,</p>\n<p> vielen Dank für die Registrierung im Portal für Informationsübermittlung und -ergänzung im Rahmen von Bewertungsverfahren nach § 137h SGB V des Gemeinsamen Bundesausschusses.</p>\n<p> Ihr Nutzerkonto wurde freigeschaltet und steht Ihnen ab sofort zur Verfügung. %{link} </p>\n<p> Diese Nachricht wurde automatisch generiert.</p>\n<p> Mit freundlichen Grüßen </p>\n"
    },
    "upload_approval_started_notification": {
      "link_text": "Zur Informationsübermittlung",
      "subject": "Portal 137h | Legitimierungsprozess wurde gestartet",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Legitimierungsprozess der Informationsübermittlung nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" wurde durch das Krankenhaus gestartet. Bitte klicken Sie auf den nachfolgenden Link, um über das Portal 137h Ihren Teil der Legitimierung der Informationsübermittlung durchführen zu können.</p>\n<p>%{link} </p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_editable_notification": {
      "link_text": "Zur Informationsübermittlung",
      "subject": "Portal 137h | Informationsübermittlung ist wieder im Status Entwurf",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>die Informationsübermittlung nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" wurde wieder auf den Status Entwurf gesetzt.</p><p>Bitte klicken Sie im Portal 137h erneut auf \"Weiter zu Bearbeitung abschließen\". Sobald der Legitimierungsprozess der Informationsübermittlung gestartet wurde, werden Sie per E-Mail informiert.</p>\n<p>%{link} </p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_hint": {
      "back_to_upload_dashboard": "Zurück zu 'Meine Verfahren'",
      "headline": "Hinweis zur Prüfung der Informationsübermittlung",
      "hint_text_completeness": "Ihre Informationsübermittlung gemäß § 137h Absatz 1 SGB V wurde erfolgreich an die Geschäftsstelle des Gemeinsamen Bundesausschusses übermittelt. Eine Prüfung auf formale Vollständigkeit der Informationsübermittlung durch die Geschäftsstelle erfolgt in Kürze.",
      "hint_text_plausibility": "Ihre Informationsübermittlung gemäß § 137h Absatz 1 SGB V wurde erfolgreich an die Geschäftsstelle des Gemeinsamen Bundesausschusses übermittelt. Eine Prüfung auf Vollständigkeit der Informationsübermittlung durch die Geschäftsstelle erfolgt in Kürze.",
      "sitename": "Hinweis"
    },
    "upload_in_review_notification": {
      "subject": "Portal 137h | Informationen wurden übermittelt",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>das Krankenhaus hat die Informationsübermittlung nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" an den Gemeinsamen Bundesausschuss gesendet. Bezüglich der nächsten Verfahrensschritte gemäß dem 2. Kapitel § 34 der Verfahrensordnung des Gemeinsamen Bundesausschusses werden Sie per E-Mail informiert.</p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_input_storage_hint": {
      "back_to_upload_dashboard": "Zurück zu 'Meine Verfahren'",
      "headline": "Hinweis zum weiteren Vorgehen",
      "hint_text": "Sie haben alle benötigten Felder der Informationsübermittlung ausgefüllt. Sobald das Krankenhaus und die betroffenen Hersteller die Bearbeitung der Pflichtfelder durch Anklicken des Buttons \"Bearbeitung abschließen\" beendet haben, können Sie im nächsten Schritt der Legitimierung die erforderlichen Unterschriften leisten und ggf. Vollmachten hochladen. Besuchen Sie dazu \"meine Verfahren\" und klicken auf \"Weiter zu Legitimierung\". Die betroffenen Hersteller können ihre Legitimierung erst starten, wenn das Krankenhaus seine Legitimierung gestartet hat. Das Krankenhaus kann seine Legitimierung erst abschließen, sobald die betroffenen Hersteller ihre Legitimierungen abgeschlossen haben.",
      "sitename": "Hinweis"
    },
    "upload_meta_data": {
      "index": {
        "site_name": "Metadaten",
        "submit": "Speichern",
        "title": "Metadaten für Informationsübermittlungen"
      },
      "show": {
        "already_checked": "Diese Daten können nicht mehr geändert werden, da sie bereits durch einen Mitarbeiter geprüft und bestätigt wurden."
      }
    },
    "upload_ready_to_approve_notification": {
      "link_text": "Zur Informationsübermittlung",
      "subject": "Portal 137h | Legitimierungsprozess kann gestartet werden",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der / die betroffenen Hersteller haben ihre Bearbeitung der Informationsübermittlung nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" abgeschlossen. Im Portal 137h können Sie, nachdem Sie Ihre Bearbeitung abgeschlossen haben, durch Klicken auf \"Weiter zu Legitimierung\" den Legitimierungsprozess starten. Bitte beachten Sie, dass Sie die Legitimierung erst abschließen können, wenn auch der Hersteller seine / die Hersteller ihre Legitimierung abgeschlossen haben.</p>\n<p>%{link} </p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_ready_to_review_notification": {
      "link_text": "Zur Informationsübermittlung",
      "subject": "Portal 137h | Legitimierung Medizinproduktehersteller abgeschlossen",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der / die betroffenen Hersteller haben ihre Legitimierung der Informationsübermittlung nach § 137h SGB V zur Methode \"%{intervention} bei %{indication}\" abgeschlossen. Bitte klicken Sie auf den nachfolgenden Link, um über das Portal 137h die Informationsübermittlung an den Gemeinsamen Bundesausschuss senden zu können.</p>\n<p>%{link} </p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_review_completeness_complete": {
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab formale Vollständigkeit",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang zunächst auf formale Vollständigkeit geprüft. Im Ergebnis stellt der G-BA die formale Vollständigkeit der übermittelten Informationen fest. Die Bestätigung des Eingangs der Informationen wird auf der Internetseite des G-BA veröffentlicht. Im nächsten Schritt wird der G-BA die übermittelten Informationen gemäß dem 2. Kapitel § 34 i.V.m. Anlage V VerfO auf Vollständigkeit prüfen.</p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_review_plausibility_complete": {
      "subject": "Ihre Informationsübermittlung an den G-BA | Prüfung ergab Vollständigkeit der übermittelten Informationen",
      "text": "<p>Sehr geehrte Damen und Herren, </p>\n<p>der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang und Feststellung der formalen Vollständigkeit auf Vollständigkeit geprüft. Im Ergebnis wurde die Vollständigkeit der übermittelten Informationen festgestellt. Die Durchführung des Informationsergänzungsverfahrens nach dem 2. Kapitel § 35 VerfO hat begonnen (siehe unter www.g-ba.de bei den Bewertungsverfahren).</p>\n<p>Mit freundlichen Grüßen</p>\n"
    },
    "upload_workflow_values": {
      "acute_shortage": {
        "back_transition_name": "Inhaltl. unvollständig – grobe Mängel (zur Nachforderung)",
        "identifier_string": "acute_shortage",
        "status_name": "Unvollständig mit groben Mängeln",
        "transition_name": "Inhaltl. unvollständig – grobe Mängel (zur Nachforderung)"
      },
      "annotation": {
        "back_transition_name": "Vollständig (Informationsergänzungsverfahren starten)",
        "identifier_string": "annotation",
        "status_name": "Informationsergänzungsverfahren",
        "transition_name": "Inhaltl. vollständig (zum Start IEV) *"
      },
      "annotation_finished": {
        "back_transition_name": "Informationsergänzungsverfahren abgeschlossen",
        "identifier_string": "annotation_finished",
        "status_name": "Informationsergänzungsverfahren abgeschlossen",
        "transition_name": "Informationsergänzungsverfahren abschließen"
      },
      "approval": {
        "back_transition_name": "Legitimierung einleiten",
        "identifier_string": "approval",
        "status_name": "Legitimierung",
        "transition_name": "Legitimierung einleiten"
      },
      "archived": {
        "back_transition_name": "Informationsübermittlung archivieren nach Ende IEV",
        "identifier_string": "archived",
        "status_name": "Archiviert",
        "transition_name": "Informationsübermittlung archivieren nach Ende IEV"
      },
      "draft": {
        "back_transition_name": "Formular wieder bearbeiten",
        "identifier_string": "draft",
        "status_name": "Entwurf",
        "transition_name": "Formular wieder bearbeiten"
      },
      "draft_finished": {
        "back_transition_name": "Bearbeitung abschließen",
        "identifier_string": "draft_finished",
        "status_name": "Bearbeitung abgeschlossen",
        "transition_name": "Bearbeitung abschließen"
      },
      "evaluate_completeness": {
        "back_transition_name": "Nächster Schritt",
        "identifier_string": "evaluate_completeness",
        "status_name": "Ergebnis der Prüfung auswählen",
        "transition_name": "Nächster Schritt"
      },
      "evaluate_plausibility": {
        "back_transition_name": "Nächster Schritt",
        "identifier_string": "evaluate_plausibility",
        "status_name": "Ergebnis der Prüfung auswählen",
        "transition_name": "Nächster Schritt"
      },
      "forward_to_review": {
        "back_transition_name": "Informationen an den G-BA übermitteln",
        "identifier_string": "forward_to_review",
        "status_name": "Prüfung",
        "transition_name": "Informationen an den G-BA übermitteln"
      },
      "incomplete": {
        "back_transition_name": "Formal unvollständig (zur Nachforderung)",
        "identifier_string": "incomplete",
        "status_name": "Formal unvollständig",
        "transition_name": "Formal unvollständig (zur Nachforderung)"
      },
      "incomplete_with_additional_requests": {
        "back_transition_name": "Formal unvollständig trotz Nachforderungen (zur Verfahrensbeendigung)",
        "identifier_string": "incomplete_with_additional_requests",
        "status_name": "Unvollständig trotz Nachforderungen",
        "transition_name": "Formal unvollständig trotz Nachforderungen (zur Verfahrensbeendigung)"
      },
      "mark_as_approval_finished": {
        "back_transition_name": "Legitimierung abschließen",
        "identifier_string": "mark_as_approval_finished",
        "status_name": "Legitimierung abgeschlossen",
        "transition_name": "Legitimierung abschließen"
      },
      "mark_as_draft_finished": {
        "back_transition_name": "Bearbeitung abschließen",
        "identifier_string": "mark_as_draft_finished",
        "status_name": "Bearbeitung abgeschlossen",
        "transition_name": "Bearbeitung abschließen"
      },
      "method_already_existing": {
        "back_transition_name": "Methode bereits in Bewertung (zur Verfahrensbeendigung)",
        "identifier_string": "method_already_existing",
        "status_name": "Methode bereits vorliegend",
        "transition_name": "Methode bereits in Bewertung (zur Verfahrensbeendigung)"
      },
      "procedure_finished": {
        "back_transition_name": "Verfahren beenden",
        "identifier_string": "procedure_finished",
        "status_name": "Verfahren beendet",
        "transition_name": "Verfahren beenden"
      },
      "review_completeness": {
        "back_transition_name": "Formale Vollständigkeitsprüfung",
        "identifier_string": "review_completeness",
        "status_name": "Formale Vollständigkeit",
        "transition_name": "Formale Vollständigkeitsprüfung"
      },
      "review_plausibility": {
        "back_transition_name": "Inhaltliche Vollständigkeitsprüfung",
        "identifier_string": "review_plausibility",
        "status_name": "Inhaltliche Vollständigkeit",
        "transition_name": "Formal vollständig (zur inhaltl. Vollständigkeitsprüfung) *"
      },
      "shortage_with_additional_requests": {
        "back_transition_name": "Inhaltl. unvollständig trotz Nachforderungen (zum Start IEV) *",
        "identifier_string": "shortage_with_additional_requests",
        "status_name": "Unvollständig trotz Nachforderungen",
        "transition_name": "Inhaltl. unvollständig trotz Nachforderungen (zum Start IEV) *"
      },
      "small_shortage": {
        "back_transition_name": "Inhaltl. unvollständig – kleine Mängel (zur Nachforderung mit/ohne erneutem Start IEV)",
        "identifier_string": "small_shortage",
        "status_name": "Unvollständig mit kleinen Mängeln",
        "transition_name": "Inhaltl. unvollständig – kleine Mängel (zur Nachforderung mit/ohne erneutem Start IEV)"
      }
    },
    "uploads": {
      "additional_requests_acute_shortage_help_text": "Mit der vordefinierten Email kann ein optionaler Freitext versendet werden.\n<br>\n<br>\nBeispiel:\n<br>\n<br>\nDas Verfahren nach § 137h Absatz 1 SGB V ist bis zur Behebung der Mängel gehemmt.\nDie Durchführung des Informationsergänzungsverfahrens nach dem 2. Kapitel § 35 VerfO wird vorerst noch nicht begonnen.\n",
      "additional_requests_generic_help_text": "Mit der vordefinierten Email kann ein optionaler Freitext versendet werden.",
      "additional_requests_incomplete": "Der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang zunächst auf formale Vollständigkeit geprüft. Im Ergebnis der Prüfung auf formale Vollständigkeit fehlt es für die Veröffentlichung der Eingangsbestätigung an Informationen. Klicken Sie auf \"Nachforderungsschreiben\" um die fehlenden Informationen einzusehen.",
      "additional_requests_incomplete_with_additional_requests": "Der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang zunächst auf formale Vollständigkeit geprüft. Im Ergebnis der Prüfung auf formale Vollständigkeit fehlt es an der formalen Vollständigkeit. Der Eingang der Informationen wird nicht auf der Internetseite des Gemeinsamen Bundesausschusses veröffentlicht und die Informationen gelten als nicht übermittelt. Klicken Sie auf \"Finales Schreiben\" um die Gründe einzusehen.",
      "additional_requests_method_already_existing": "Zur gegenständlichen Methode wurden bereits zuvor durch ein anderes Krankenhaus Informationen nach § 137h Absatz 1 SGB V an den Gemeinsamen Bundesausschuss übermittelt. Klicken Sie auf \"Finales Schreiben\" um weitere Informationen zum Verfahren einzusehen.",
      "additional_requests_small_or_acute_shortage": "Der Gemeinsame Bundesausschuss (G-BA) hat gemäß dem 2. Kapitel § 34 i.V.m. Anlage V zum 2. Kapitel der Verfahrensordnung (VerfO) des G-BA die übermittelten Informationen nach ihrem Eingang und Feststellung der formalen Vollständigkeit auf Vollständigkeit geprüft. Im Ergebnis der Prüfung auf Vollständigkeit bestehen erhebliche Unvollständigkeiten der übermittelten Informationen. Klicken Sie auf \"Nachforderungsschreiben\" um die fehlenden Informationen einzusehen.",
      "additional_requests_small_shortage_help_text": "Mit der vordefinierten Email kann ein optionaler Freitext versendet werden.\n<br>\n<br>\nBeispiel 1:\n<br>\nUm Verfahrensverzögerungen zu vermeiden, wurde die Durchführung des Informationsergänzungsverfahrens nach dem 2. Kapitel § 35 VerfO trotz dieser Nachforderung begonnen (siehe unter www.g-ba.de bei den Bewertungsverfahren).\n<br>\n<br>\nBeispiel 2:\n<br>\nDas Verfahren nach § 137h Absatz 1 SGB V ist bis zur Behebung der Mängel gehemmt.\n",
      "create": {
        "success": "Erfolgreich"
      },
      "delete": {
        "success": "Erfolgreich gelöscht"
      },
      "details": {
        "archive_description": "Hier können alle verfügbaren Informationen zum Verfahren als Zip-Archiv heruntergeladen werden.",
        "archive_link": "Archiv herunterladen",
        "archive_zip": "Archiv als ZIP-Datei",
        "combined_pdf_description": "In diesem PDF werden die Informationsübermittlung zusammen mit den Informationsergänzungen und Tabellen in Dialogform dargestellt.",
        "combined_pdf_link": "PDF herunterladen",
        "header_deadlines": "Fristen",
        "header_profile": "Steckbrief",
        "show_form": "Formular anzeigen",
        "show_upload": "Übermittlung anzeigen"
      },
      "edit": {
        "headline": "Informationsübermittlung bearbeiten"
      },
      "empty_fields": {
        "many": "offene Felder:",
        "more_than_10": "Noch mehr als %{upper_bound} offene Felder",
        "one": "offenes Feld:"
      },
      "feed": {
        "description": "Die Liste %{link} erhalten."
      },
      "form_steps": {
        "back": "Abschnitt zurück",
        "next": "Nächster Abschnitt",
        "overview": "Übersicht",
        "step_one": {
          "paragraph0": "des Gemeinsamen Bundesausschusses (G-BA) mit dem Sie die Möglichkeit nutzen, Ihre Informationsübermittlung nach § 137h Absatz 1 SGB V auf digitalem Weg an den G-BA zu übermitteln.",
          "paragraph1": "Das Portal 137h ermöglicht Ihnen als Krankenhaus sowie dem / den betroffenen Medizinproduktehersteller(n) die gleichzeitige digitale Bearbeitung der durch das Krankenhaus und durch die Medizinproduktehersteller auszufüllenden Abschnitte des Informationsübermittlungsformulars. Das Krankenhaus wird aufgefordert, in einem der ersten Schritte der Anwendung die betroffenen Medizinproduktehersteller von Medizinprodukten hoher Risikoklasse zur gemeinsamen Bearbeitung einzuladen. Hierfür gibt das Krankenhaus die Medizinproduktehersteller, deren Medizinprodukte hoher Risikoklasse und die Kontakt-Email-Adressen der Medizinproduktehersteller an und versendet einen Einladungslink.",
          "paragraph2": "Anschließend können die Beteiligten die Bearbeitung der auszufüllenden Formularangaben beginnen. Die eingegebenen Daten können jederzeit zwischengespeichert werden, sodass die Bearbeitung durch die Nutzer jederzeit unterbrochen und zu einem beliebigen Zeitpunkt fortgeführt werden kann. Beim Verlassen der Anwendung wird auf ggf. nicht gespeicherte Änderungen hingewiesen. Bitte nutzen Sie zur hierarchischen Navigation im Portal 137h allein die in der Portalanwendung integrierten Buttons und Links und nicht die Navigation über Ihren Browser (Beispiel: Zurück-Button der Portalanwendung und nicht den Zurück-Button des Browsers verwenden). Auf der rechten Seite der Portalanwendung finden Sie die Schnellnavigation, die Auflistung noch offener Aufgaben sowie Hinweise zur Bearbeitung bzw. zum Bearbeitungsstand. Die Informationsübermittlung über das Portal 137h bietet Ihnen einen einfachen Up-Load von Dateien wie beispielsweise Literatur, digitalen Unterschriften und Vollmachten.",
          "paragraph3": "Die Einreichung von Informationen an den G-BA mittels einer DVD ist nur noch für die Übermittlung von hochvertraulichen Unterlagen erforderlich.",
          "paragraph4": "Sobald das Krankenhaus und der / die Medizinproduktehersteller sämtliche Pflichtangaben in den jeweils auszufüllenden Formularabschnitten getätigt und die Bearbeitung abgeschlossen haben, erfolgt im nachfolgenden Schritt der Legitimierung die Abgabe der zu tätigenden Unterschriften sowie ggf. das Hochladen von Vollmachten für bevollmächtigte Personen / Unternehmen. Nachdem das Krankenhaus und der / die Medizinproduktehersteller ihre Legitimierungen abgeschlossen haben, kann das Krankenhaus alle in das 137h-Portal eingegebenen Informationen an den G-BA übermitteln.",
          "paragraph5": "Hierfür wird nach der Bearbeitung durch das Krankenhaus und dem / den Medizinproduktehersteller/n eine PDF-Datei mit sämtlichen durch das Krankenhaus und durch den / die ins Einvernehmen gesetzten Medizinproduktehersteller auszufüllenden Abschnitte des Informationsübermittlungsformulars generiert. Das Krankenhaus wird damit seinem gesetzlichen Auftrag zur Übermittlung von Informationen über den Stand der wissenschaftlichen Erkenntnisse zu dieser Methode sowie zu der Anwendung des Medizinprodukts, insbesondere von Daten zum klinischen Nutzen und vollständige Daten zu durchgeführten klinischen Studien mit dem Medizinprodukt im Einvernehmen mit dem / den Hersteller/n des Medizinprodukts gemäß § 137h Absatz 1 SGB V gerecht.",
          "title": "Herzlich Willkommen im Portal 137h"
        },
        "step_two": {
          "title": "Metadaten zur Informationsübermittlung"
        },
        "submit": "Medizinproduktehersteller hinzufügen"
      },
      "index": {
        "all": "Alle Informationsübermittlungen",
        "confirm_delete": "Wollen Sie diese Informationsübermittlung wirklich löschen?",
        "confirm_status_change": "Soll der Status wirklich gewechselt werden?",
        "headline": "Verfahren nach § 137h SGB V",
        "last_changes": "Letzte Änderungen",
        "none": "Keine Informationsübermittlungen vorhanden",
        "own": "Eigene Informationsübermittlungen",
        "paragraph1": "In der hier angebotenen Übersicht finden Sie die Beschlüsse, Bekanntmachungen und Verfahrensstände zu allen neuen Untersuchungs- und Behandlungsmethoden mit Medizinprodukten hoher Risikoklasse, zu denen der G-BA eine Beratung gemäß § 137h Absatz 6 SGB V oder eine Bewertung gemäß § 137h Absatz 1 SGB V durchführt oder bereits vorgenommen hat.",
        "paragraph2": "Informationen zu den fristgebundenen Verfahren nach § 137h SGB V und den dahingehenden Beratungsangeboten finden Sie unter dem Thema <a href='https://www.g-ba.de/themen/methodenbewertung/bewertung-erprobung/137h/'> Methoden mit Medizinprodukten hoher Risikoklasse</a>",
        "paragraph3": "Alle Unterlagen zu den Verfahren der Nutzenbewertung nach § 137h SGB V können elektronisch über das Portal eingereicht werden: <a href='%{new_upload_path}'>Neue Verfahrensunterlagen hochladen</a>",
        "rss_feed": "als RSS-Feed",
        "start_process": "Zur Prüfung",
        "subheadline": "Einreichung der Unterlagen"
      },
      "new": {
        "button": "Neue Informationsübermittlung starten",
        "headline": "Neue Informationsübermittlung starten"
      },
      "overview": {
        "apply_filter": "Filter anwenden",
        "filter": {
          "choose": "Bitte wählen",
          "editor_ref": "Bearbeiter/in REF A-Z",
          "editor_ref_rep": "Bearbeiter/in REF Vertretung A-Z",
          "editor_sb": "Bearbeiter/in SB A-Z",
          "editor_sb_rep": "Bearbeiter/in SB Vertretung A-Z",
          "indication": "Indikation A-Z",
          "institution": "Institution A-Z",
          "intervention": "Intervention A-Z",
          "manufacturer": "Hersteller A-Z",
          "medical_device": "Produkt A-Z",
          "product_class": "Produktklasse A-Z",
          "show_more": "Mehr anzeigen",
          "status": "Status",
          "title": "Methodenbezeichnung (Titel) A-Z"
        },
        "reset": "zurücksetzen"
      },
      "read_only": {
        "back_to_draft": "Informationsübermittlung (Leseansicht)",
        "back_to_draft_message": "Da Ihre Übermittlung bereits geprüft und bestätigt wurde, können sie keine Änderungen an den Daten vornehmen.",
        "edit_data": "Angaben ändern",
        "headline": "Prüfung",
        "success": "Ihre Angaben werden in Kürze geprüft.",
        "to_review": "Zur Prüfung freigeben",
        "uncomleted_error": "Bitte füllen Sie zuerst alle Pflichtfelder aus."
      },
      "required": "* Pflichtfeld",
      "save": {
        "success": "Erfolgreich gespeichert"
      },
      "show": {
        "confirmation": "Hinweis",
        "headline": "Verfahren nach § 137h SGB V",
        "subscription": {
          "done": "Sie lassen sich über Änderungen informieren",
          "edit": "Abos verwalten",
          "subscribe": "Über Änderungen informieren lassen"
        }
      },
      "state_change": {
        "success": "Statuswechsel erfolgreich"
      },
      "upload-form": {
        "auto_save_failed": "Beim automatischen Speichern ist ein Fehler aufgetreten. Mit Verlassen der Seite gehen ungespeicherte Änderungen verloren. Klicken Sie auf \"Abbrechen\" und Speichern Sie Ihre Daten mit dem Button \"Zwischenspeichern\" manuell.",
        "confirm_leave": "Sind sie sicher, dass Sie die Seite verlassen möchten? Nicht gespeicherte Änderungen gehen dabei verloren.",
        "copy_paragragraph": "Sofern Sie in Abschnitt I Nummer 3 mehrere Medizinprodukte hoher Risikoklassen angegeben haben, vervielfältigen Sie diesen Abschnitt entsprechend der Anzahl der Hersteller.",
        "fallback": "Kein Formular vorhanden",
        "save": "Zwischenspeichern",
        "submit": "Speichern und verlassen"
      }
    },
    "uploads_name_external": "Alle Verfahren",
    "uploads_name_internal": "Verfahrensübersicht",
    "user_personal_data_notification": {
      "subject": "Persönlichen Daten Änderungsanforderung",
      "text": "<p> Liebe Kollegin, lieber Kollege,</p>\n<p>im Portal 137h hat eine Nutzerin oder ein Nutzer ihre bzw. seine persönlichen Daten im Benutzerkonto geändert. Klicken Sie auf den nachfolgenden Link, um die geänderten Daten auf Plausibilität zu prüfen und das Benutzerkonto, sofern die Angaben plausibel sind, freizuschalten. Erst wenn das Benutzerkonto freigeschaltet ist, kann die Nutzerin oder der Nutzer die Änderungen sehen. Die Freigabe des Benutzerkontos sollte innerhalb von 24 Stunden eines Werktages erfolgen (das Wochenende zählt nicht mit).</p>\n<p>%{link}</p>\n"
    },
    "users": {
      "edit": {
        "confirmation": {
          "personal_data_change_mail": {
            "all": "Die Änderungen wurden erfolgreich übernommen, müssen jedoch erst vom G-BA freigeschalten werden. Die Freischaltung dauert in der Regel 1-2 Werktage.",
            "some": "Die Änderungen wurden erfolgreich übernommen, manche Änderungen müssen jedoch erst vom G-BA freigeschalten werden. Die Freischaltung dauert in der Regel 1-2 Werktage."
          },
          "unconfirmed": "Ausstehend zur Überprüfung"
        },
        "success": "Ihre Account Daten wurden erfolgreich geändert.",
        "validation": {
          "blank": "Feld darf nicht leer sein."
        }
      },
      "edit_data": {
        "required": "* Pflichtfelder - Änderungen an diesen Feldern müssen bestätigt werden.",
        "side_bar": {
          "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis porta urna.",
          "title": "Hinweis"
        },
        "title": "Daten ändern"
      },
      "email": {
        "review": {
          "link_title": "Hier geht es zur Prüfung und Aktualisierung"
        }
      },
      "review": {
        "from": "Bisher",
        "side_bar": {
          "text": "Der Nutzer hat Änderungen an seinen Stammdaten vorgenommen. Bitte prüfen Sie die Angaben in der Spalte „Geändert“. Mit „Bestätigen“ werden die neuen Daten übernommen, mit „Ablehnen“ bleiben die bisherigen Daten bestehen.",
          "title": "Hinweis"
        },
        "success": {
          "confirm": "Die Änderungen wurden erfolgreich übernommen.",
          "reject": "Die Änderungen wurden erfolgreich abgelehnt."
        },
        "title": "Überprüfung der geänderten Daten",
        "to": "Geändert"
      }
    },
    "wizard": {
      "navigation": {
        "link_separator": " oder ",
        "next": "Nächster Schritt",
        "previous": "Schritt zurück"
      }
    },
    "working_protocol": {
      "approval": {
        "editor": "In diesem Schritt der Legitimierung sind durch den Medizinproduktehersteller die Unterschriften zu den Abschnitten III A und III B und damit die Erklärung des Einvernehmens mit der Informationsübermittlung zu tätigen. Bitte wählen Sie, ob Sie die Unterschrift in elektronischer Form unter Verwendung eines PDFs mit qualifizierter elektronischer Signatur tätigen oder alternativ per Fax senden möchten. Laden Sie hierzu die jeweils zu unterzeichnenden Formularabschnitte herunter und laden Sie die Formularabschnitte anschließend entweder mit den getätigten qualifizierten elektronischen Signaturen wieder hoch oder drucken Sie die Formularabschnitte aus, unterzeichnen Sie diese und senden Sie diese per Fax an die angegebene Faxnummer. Sofern für den Medizinproduktehersteller eine durch den Medizinproduktehersteller bevollmächtigte Person oder ein bevollmächtigtes Unternehmen die Informationen und Unterschriften getätigt hat, ist in diesem Schritt der Legitimierung auch die Vollmacht des Medizinprodukteherstellers an die bevollmächtigte Person oder das bevollmächtigte Unternehmen hochzuladen bzw. per Fax an die angegebene Faxnummer zu übersenden.",
        "owner": "In diesem Schritt der Legitimierung ist die Unterschrift des Krankenhauses zum Abschnitt V des Formulars und damit die Genehmigung der Informationsübermittlung zu tätigen. Eine für das Krankenhaus im Umfang der vorstehenden Informationsübermittlung nach § 137h Absatz 1 SGB V vertretungsberechtigte Person oder eine von ihr bevollmächtigte Person muss die Unterschrift zum Abschnitt V leisten. Fehlt es an einer solchen Unterschrift, gilt die Information als nicht eingegangen. Bitte wählen Sie, ob Sie die Unterschrift in elektronischer Form unter Verwendung eines PDFs mit qualifizierter elektronischer Signatur tätigen oder alternativ per Fax senden möchten. Laden Sie hierzu das zu unterzeichnende Formular herunter und laden Sie anschließend das Formular entweder mit der getätigten qualifizierten elektronischen Signatur wieder hoch oder drucken Sie das Formular aus, unterzeichnen es und senden es per Fax an die angegebene Faxnummer. Sofern für das Krankenhaus eine durch das Krankenhaus bevollmächtigte Person oder ein bevollmächtigtes Unternehmen die Informationen und Unterschrift getätigt hat, ist in diesem Schritt der Legitimierung auch die Vollmacht des Krankenhauses an die bevollmächtigte Person oder das bevollmächtigte Unternehmen hochzuladen bzw. per Fax an die angegebene Faxnummer zu übersenden. Bitte beachten Sie, dass die Informationen erst an den G-BA übermittelt werden können, wenn auch die betroffenen Medizinproduktehersteller ihre jeweiligen Legitimierungen abgeschlossen haben."
      }
    }
  }
}